export const rdpProductGridboxResponse = {
  ageRestriction: false,
  awards: [],
  brand: {
    logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
    name: "PARKSIDE®",
    url: "/q/search?q=parkside",
    id: "PARK",
    showBrand: true,
  },
  canonicalPath: "/p/parkside-20v-4ah-akku-pap-20-b3-mit-cell-balancing/p100392978",
  canonicalUrl: "/p/parkside-20v-4ah-akku-pap-20-b3-mit-cell-balancing/p100392978",
  category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
  categorySecondaryPath: "0/41/4111/411119/41111910",
  dealOfDay: {
    active: false,
  },
  designTheme: "default",
  disclaimers: [
    {
      id: "code_100392978_e6733ad6",
      type: "CODE",
      value: "Basic",
    },
    {
      id: "code_100392978_0c8b73ee",
      type: "CODE",
      value: "Price",
    },
  ],
  displayFreeDelivery: false,
  energyLabels: [],
  erpNumber: "100392978",
  flashSales: false,
  fullTitle: "PARKSIDE® 20V / 4Ah Akku »PAP 20 B3«, mit Cell-Balancing",
  gs1Attributes: [],
  havingPrice: true,
  havingThreesixty: false,
  havingVideos: false,
  highlightedSeals: 0,
  ians: ["484038"],
  image: "https://www.lidl.de/assets/gcp01e021a87f7c402686b597d0b74153c0.jpg",
  image_V1: {
    image: "https://www.lidl.de/assets/gcp01e021a87f7c402686b597d0b74153c0.jpg",
    accessibility: "Parkside X20V Team Akku für Akkuschrauber.",
  },
  isUsedProduct: false,
  imageList: [
    "https://www.lidl.de/assets/gcp01e021a87f7c402686b597d0b74153c0.jpg",
    "https://www.lidl.de/assets/gcp0954850651eb48b0b0ac22cf2b5605ad.jpg",
    "https://www.lidl.de/assets/gcp70430cbdf7f74f1683ba41dd876dc954.jpg",
  ],
  imageList_V1: [
    {
      image: "https://www.lidl.de/assets/gcp01e021a87f7c402686b597d0b74153c0.jpg",
      accessibility: "Parkside X20V Team Akku für Akkuschrauber.",
    },
    {
      image: "https://www.lidl.de/assets/gcp0954850651eb48b0b0ac22cf2b5605ad.jpg",
      accessibility: "Parkside X20V Team Akku",
    },
    {
      image: "https://www.lidl.de/assets/gcp70430cbdf7f74f1683ba41dd876dc954.jpg",
      accessibility: "Parkside X20V Team Akku",
    },
  ],
  keyfacts: {
    analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    fullTitle: "PARKSIDE® 20V / 4Ah Akku »PAP 20 B3«, mit Cell-Balancing",
    moreDetails: "Weitere Produktdetails",
    supplementalDescription:
      '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>',
    title: "20V / 4Ah Akku »PAP 20 B3«, mit Cell-Balancing",
    wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
    wonCategoryPrimaryPath: "0/12/1210",
  },
  lidlPlus: [],
  multipack: false,
  online: true,
  preventSelling: false,
  price: {
    currencyCode: "EUR",
    currencyCodeSecond: "",
    currencySymbol: "€",
    currencySymbolSecond: "",
    hasStar: true,
    hasVat: true,
    price: 24.99,
    specialTaxes: [],
    variantsHaveDifferentPrices: false,
  },
  productId: 100392978,
  productType: "FLAT",
  productOrigin: "progress_event",
  quickAddToCart: false,
  ratings: {
    average: 4.8,
    count: 3816,
    recommendedNo: 89,
    recommendedYes: 2867,
    sizePercentage: 0,
    topRated: true,
    text: "Top Kundenbewertungen",
  },
  regions: [],
  regionsPrices: {},
  ribbons: [
    {
      type: "TOP_RATED",
      text: "Top Kundenbewertungen",
      theme: "top-rated",
      icon: "star-10",
    },
  ],
  renderedTs: 1770027369,
  seals: [],
  stockAvailability: {
    availabilityIndicator: 3,
    badgeInfo: {
      badges: [
        {
          text: "lieferbar",
          type: "AVAILABLE_ONLINE",
        },
      ],
    },
    onlineAvailable: true,
    orderableQuantities: [
      {
        unit: "Stück",
        value: 1,
      },
      {
        unit: "Stück",
        value: 2,
      },
      {
        unit: "Stück",
        value: 3,
      },
      {
        unit: "Stück",
        value: 4,
      },
      {
        unit: "Stück",
        value: 5,
      },
      {
        unit: "Stück",
        value: 6,
      },
    ],
    minOrderableQuantity: 1,
  },
  store: false,
  title: "20V / 4Ah Akku »PAP 20 B3«, mit Cell-Balancing",
  zones: {},
};

export const productsGridboxResponse = [
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-hammerbohrer-set-pbhz-2-b2/p100364938",
    canonicalUrl: "/p/parkside-hammerbohrer-set-pbhz-2-b2/p100364938",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
    categorySecondaryPath: "0/41/4111/411119/41111988",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100364938_60ef13f5",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100364938_e8a6257c",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100364938",
    flashSales: false,
    fullTitle: "PARKSIDE® Hammerbohrer-Set »PBHZ 2 B2«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["417402"],
    image: "https://www.lidl.de/assets/gcp76ae31e3a53345ce8371575df9cad91d.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp76ae31e3a53345ce8371575df9cad91d.jpeg",
      accessibility: "Sechs Bohrerspitzen für Beton.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp76ae31e3a53345ce8371575df9cad91d.jpeg",
      "https://www.lidl.de/assets/gcpa16adf947d8e4c8da3ffcfa5d064e2c4.jpeg",
      "https://www.lidl.de/assets/gcp55a5a24eb55e486ab14b26fb15fa0e91.jpeg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp76ae31e3a53345ce8371575df9cad91d.jpeg",
        accessibility: "Sechs Bohrerspitzen für Beton.",
      },
      {
        image: "https://www.lidl.de/assets/gcpa16adf947d8e4c8da3ffcfa5d064e2c4.jpeg",
        accessibility: "Ein Satz mit fünf Bohrern für Beton.",
      },
      {
        image: "https://www.lidl.de/assets/gcp55a5a24eb55e486ab14b26fb15fa0e91.jpeg",
        accessibility: "Drei Bohrer für Beton.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
      description: '<p><span style="color: #0050aa;">✓</span> Passend f&uuml;r Bohrmaschinen mit SDS-Plus-Aufnahme</p>',
      fullTitle: "PARKSIDE® Hammerbohrer-Set »PBHZ 2 B2«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Arten:</strong> L&auml;nge 60 cm / 100 cm<br /> <strong>Einsatz: </strong>Stein, Leichtbeton und Ziegeln<br /> <strong>Aufnahme:</strong> SDS-Plus</p>",
      title: "Hammerbohrer-Set »PBHZ 2 B2«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100364938,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.2,
      count: 23,
      recommendedNo: 4,
      recommendedYes: 17,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901255,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Hammerbohrer-Set »PBHZ 2 B2«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath:
      "/p/parkside-performance-20-v-akku-drehschlagschrauber-ppdssa-20-li-a1-ohne-akku-und-ladegeraet/p100388571",
    canonicalUrl:
      "/p/parkside-performance-20-v-akku-drehschlagschrauber-ppdssa-20-li-a1-ohne-akku-und-ladegeraet/p100388571",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111998",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100388571_6340fb36",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100388571_dba1f3cd",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100388571",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Drehschlagschrauber »PPDSSA 20-Li A1«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["490887"],
    image: "https://www.lidl.de/assets/gcpfd4af46a70be421bb94ba396dc376d7f.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpfd4af46a70be421bb94ba396dc376d7f.jpg",
      accessibility: "Akku-Schlagschrauber Parkside mit Akku.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpfd4af46a70be421bb94ba396dc376d7f.jpg",
      "https://www.lidl.de/assets/gcp78244844044d4f11b9e88301044286e3.jpg",
      "https://www.lidl.de/assets/gcp93653487a54346dd884ae9a4fbae03d9.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpfd4af46a70be421bb94ba396dc376d7f.jpg",
        accessibility: "Akku-Schlagschrauber Parkside mit Akku.",
      },
      {
        image: "https://www.lidl.de/assets/gcp78244844044d4f11b9e88301044286e3.jpg",
        accessibility: "Parkside X20V Team Ladegerät und Akku verboten.",
      },
      {
        image: "https://www.lidl.de/assets/gcp93653487a54346dd884ae9a4fbae03d9.jpg",
        accessibility: "Eine Parkside Schlagschrauber wird zum Wechseln eines Autoreifens verwendet.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Drehschlagschrauber »PPDSSA 20-Li A1«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Leerlaufdrehzahl: </strong><span>0&ndash;1500 min<sup>-1</sup> / 0&ndash;3000 min<sup>-1</sup></span><br /> <strong>Schlagzahl: </strong><span>0&ndash;1800 min<sup>-1</sup> / 0&ndash;3550 min<sup>-1</sup></span></p>',
      title: "20 V Akku-Drehschlagschrauber »PPDSSA 20-Li A1«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 89.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100388571,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.4,
      count: 132,
      recommendedNo: 15,
      recommendedYes: 110,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770023411,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395394",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Drehschlagschrauber »PPDSSA 20-Li A1«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-handstaubsauger-phssa-20-li-d2-ohne-akku-und-ladegeraet/p100391629",
    canonicalUrl: "/p/parkside-20-v-akku-handstaubsauger-phssa-20-li-d2-ohne-akku-und-ladegeraet/p100391629",
    category: "Kategorien/Haushalt & Küche/Reinigung/Staubsauger/Handstaubsauger",
    categorySecondaryPath: "0/20/2045/204512/20451212",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100391629_1e98e05b",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100391629_e800de33",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100391629",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Handstaubsauger »PHSSA 20-Li D2«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["479370"],
    image: "https://www.lidl.de/assets/gcpd99a6afc0ce24d4cbc175cc7f8f159e7.png",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpd99a6afc0ce24d4cbc175cc7f8f159e7.png",
      accessibility: "Akku-Handstaubsauger von Parkside mit verschiedenen Aufsätzen.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpd99a6afc0ce24d4cbc175cc7f8f159e7.png",
      "https://www.lidl.de/assets/gcp63b2ed1522e64dd48b8ba71c3bcb542a.jpg",
      "https://www.lidl.de/assets/gcp063e950fe3824727bb72edf57bdbf696.png",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpd99a6afc0ce24d4cbc175cc7f8f159e7.png",
        accessibility: "Akku-Handstaubsauger von Parkside mit verschiedenen Aufsätzen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp63b2ed1522e64dd48b8ba71c3bcb542a.jpg",
        accessibility: "Parkside X20V Team Akkuladegerät, mit einem Verbotsschild markiert.",
      },
      {
        image: "https://www.lidl.de/assets/gcp063e950fe3824727bb72edf57bdbf696.png",
        accessibility:
          "Eine Person verwendet einen Akkusauger von Parkside, um Holzspäne von einem Holztisch zu entfernen.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Haushalt & Küche/Reinigung/Staubsauger/Handstaubsauger",
      fullTitle: "PARKSIDE® 20 V Akku-Handstaubsauger »PHSSA 20-Li D2«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Laufzeit</strong>: 17 min (2 Ah) / 34 min (4 Ah)<br /> <strong>Staubbeh&auml;ltervolumen</strong>: 650 ml</p>',
      title: "20 V Akku-Handstaubsauger »PHSSA 20-Li D2«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 32.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100391629,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.5,
      count: 148,
      recommendedNo: 12,
      recommendedYes: 133,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770014290,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [],
          text: [],
          flag: [],
          list: [
            {
              key: "Bundle",
              listElement: [
                {
                  value: "100391689",
                },
                {
                  value: "100395394",
                },
              ],
            },
          ],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1755900000,
    title: "20 V Akku-Handstaubsauger »PHSSA 20-Li D2«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100391931",
    canonicalUrl: "/p/parkside-20v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100391931",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100391931_f0326a34",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100391931_82ab73d1",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100391931",
    flashSales: false,
    fullTitle: "PARKSIDE® 20V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["481666"],
    image: "https://www.lidl.de/assets/gcpcd168f512aa44c9b8eb1d178cbb23678.png",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpcd168f512aa44c9b8eb1d178cbb23678.png",
      accessibility: "",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpcd168f512aa44c9b8eb1d178cbb23678.png",
      "https://www.lidl.de/assets/gcpb30ea8dd6ae945f098e1a5af298ad5e7.jpg",
      "https://www.lidl.de/assets/gcp509b2f702e2e4cfdb337b109f4edf380.png",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpcd168f512aa44c9b8eb1d178cbb23678.png",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcpb30ea8dd6ae945f098e1a5af298ad5e7.jpg",
        accessibility: "Mann mit Parkside Bohrmaschine schraubt eine Schraube in Holz.",
      },
      {
        image: "https://www.lidl.de/assets/gcp509b2f702e2e4cfdb337b109f4edf380.png",
        accessibility: "",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team </span></strong><br /> <strong>Akku-Spannung:&nbsp;</strong>20 Volt<br /> <strong>Akku-Kapazit&auml;t: </strong>2 Ah</p>',
      title: "20V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100391931,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 240,
      recommendedNo: 10,
      recommendedYes: 224,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770026169,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-kettensaege-paks-20-li-e5-ohne-akku-und-ladegeraet/p100393724",
    canonicalUrl: "/p/parkside-20-v-akku-kettensaege-paks-20-li-e5-ohne-akku-und-ladegeraet/p100393724",
    category: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Kettensägen & Häcksler",
    categorySecondaryPath: "0/41/4110/411012/41101214",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100393724_5204495b",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100393724_04a1d4c1",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100393724",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Kettensäge »PAKS 20-Li E5«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["480995"],
    image: "https://www.lidl.de/assets/gcpf6c72318d4ea460aae5e00d1d6ee4c93.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpf6c72318d4ea460aae5e00d1d6ee4c93.jpg",
      accessibility: "Gezeigt wird eine Parkside Akku-Kettensäge mit einer 10 Zoll Schwertlänge.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpf6c72318d4ea460aae5e00d1d6ee4c93.jpg",
      "https://www.lidl.de/assets/gcpc7c4c8bf4a714b00a4904ab6acb94f2b.jpg",
      "https://www.lidl.de/assets/gcpc92230d2f6ba41ea870c639dccb446ce.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpf6c72318d4ea460aae5e00d1d6ee4c93.jpg",
        accessibility: "Gezeigt wird eine Parkside Akku-Kettensäge mit einer 10 Zoll Schwertlänge.",
      },
      {
        image: "https://www.lidl.de/assets/gcpc7c4c8bf4a714b00a4904ab6acb94f2b.jpg",
        accessibility: "Parkside X20 Team Ladegerät: Nicht verwenden.",
      },
      {
        image: "https://www.lidl.de/assets/gcpc92230d2f6ba41ea870c639dccb446ce.jpg",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Kettensägen & Häcksler",
      fullTitle: "PARKSIDE® 20 V Akku-Kettensäge »PAKS 20-Li E5«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Kettengeschwindigkeit</strong>: max. 10 m/s&nbsp;<br /> <strong>Schnittl&auml;nge</strong>: max. 23 cm</p>',
      title: "20 V Akku-Kettensäge »PAKS 20-Li E5«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Gartengeräte & Gartenwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1212",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100393724,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.4,
      count: 144,
      recommendedNo: 15,
      recommendedYes: 117,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770023872,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Kettensäge »PAKS 20-Li E5«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-2-x-4-5-a-akku-doppelladegeraet-pdslg-20-b1-ohne-akku/p100395235",
    canonicalUrl: "/p/parkside-20-v-2-x-4-5-a-akku-doppelladegeraet-pdslg-20-b1-ohne-akku/p100395235",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100395235_17a98824",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100395235_56d47453",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100395235",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 2 x 4,5 A Akku-Doppelladegerät »PDSLG 20 B1«, ohne Akku",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["505112"],
    image: "https://www.lidl.de/assets/gcpa2d866d6ac5240f9bf04c9f3ccde0b46.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpa2d866d6ac5240f9bf04c9f3ccde0b46.jpg",
      accessibility: "Parkside Akkuladegerät mit zwei Akkus, zeigt Ladezeiten für verschiedene Kapazitäten an.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpa2d866d6ac5240f9bf04c9f3ccde0b46.jpg",
      "https://www.lidl.de/assets/gcp78397ed94e934a3aafbca4e7666321c2.jpg",
      "https://www.lidl.de/assets/gcpa1c69000fab1471c93a5b8157860427c.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpa2d866d6ac5240f9bf04c9f3ccde0b46.jpg",
        accessibility: "Parkside Akkuladegerät mit zwei Akkus, zeigt Ladezeiten für verschiedene Kapazitäten an.",
      },
      {
        image: "https://www.lidl.de/assets/gcp78397ed94e934a3aafbca4e7666321c2.jpg",
        accessibility:
          "Ein Parkside X20V Team Akku wird auf einem Parkside Ladegerät geladen, mit einem gelben Kreuz darüber.",
      },
      {
        image: "https://www.lidl.de/assets/gcpa1c69000fab1471c93a5b8157860427c.jpg",
        accessibility: "Parkside Ladegerät mit zwei Akkus, mit einer Kapazitäts- und Ladezeittabelle.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V / 2 x 4,5 A Akku-Doppelladegerät »PDSLG 20 B1«, ohne Akku",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Bemessungsaufnahme</strong>: 220 W<br /> <strong>Ladestrom</strong>: max. 2 x 4,5 A</p>',
      title: "20 V / 2 x 4,5 A Akku-Doppelladegerät »PDSLG 20 B1«, ohne Akku",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100395235,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 58,
      recommendedNo: 2,
      recommendedYes: 55,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1769901263,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 2 x 4,5 A Akku-Doppelladegerät »PDSLG 20 B1«, ohne Akku ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-pap-20-b1-20-v-ladegeraet-plg-20-c1/p100395386",
    canonicalUrl: "/p/parkside-20-v-akku-pap-20-b1-20-v-ladegeraet-plg-20-c1/p100395386",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100395386_cfafbcb6",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100395386_69cae0ee",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100395386",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku »PAP 20 B1« / 20 V Ladegerät »PLG 20 C1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["505120"],
    image: "https://www.lidl.de/assets/gcp76474adf7c2540a29a5fc7b8538ce864.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp76474adf7c2540a29a5fc7b8538ce864.jpg",
      accessibility: "Ein schwarzer und roter Akku wird in einem passenden Ladegerät geladen.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp76474adf7c2540a29a5fc7b8538ce864.jpg",
      "https://www.lidl.de/assets/gcp396900db4ade430c967071f8e6e1d161.jpg",
      "https://www.lidl.de/assets/gcpf1bf3b7eef0d49d1a514ccb0775e6fc1.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp76474adf7c2540a29a5fc7b8538ce864.jpg",
        accessibility: "Ein schwarzer und roter Akku wird in einem passenden Ladegerät geladen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp396900db4ade430c967071f8e6e1d161.jpg",
        accessibility: "Parkside Akku und Ladegerät in Schwarz und Rot",
      },
      {
        image: "https://www.lidl.de/assets/gcpf1bf3b7eef0d49d1a514ccb0775e6fc1.jpg",
        accessibility: "Parkside X 20V Team Akku lädt auf einem schwarzen Ladegerät.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V Akku »PAP 20 B1« / 20 V Ladegerät »PLG 20 C1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 2 Ah</p>',
      title: "20 V Akku »PAP 20 B1« / 20 V Ladegerät »PLG 20 C1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 19.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100395386,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 115,
      recommendedNo: 4,
      recommendedYes: 107,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1769932682,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1764975600,
    title: "20 V Akku »PAP 20 B1« / 20 V Ladegerät »PLG 20 C1«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-schnellladegeraet-plg-20-c3/p100396589",
    canonicalUrl: "/p/parkside-20-v-akku-schnellladegeraet-plg-20-c3/p100396589",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396589_7a8552e1",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396589_b955b729",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396589",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Schnellladegerät »PLG 20 C3«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["485604"],
    image: "https://www.lidl.de/assets/gcp41bc5b8e5aee4e8f83ab021d832be7db.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp41bc5b8e5aee4e8f83ab021d832be7db.jpg",
      accessibility: "Schwarzes Elektrowerkzeug-Akkuladegerät mit Leuchtanzeigen und Netzkabel",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp41bc5b8e5aee4e8f83ab021d832be7db.jpg",
      "https://www.lidl.de/assets/gcpb83e436519944bccbabef48e06c8b7e5.jpg",
      "https://www.lidl.de/assets/gcp033794409b2a4cb6be165026b5889a47.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp41bc5b8e5aee4e8f83ab021d832be7db.jpg",
        accessibility: "Schwarzes Elektrowerkzeug-Akkuladegerät mit Leuchtanzeigen und Netzkabel",
      },
      {
        image: "https://www.lidl.de/assets/gcpb83e436519944bccbabef48e06c8b7e5.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcp033794409b2a4cb6be165026b5889a47.jpg",
        accessibility: "Schwarzes Akkuladegerät mit grauem Akku, mit gelbem X darauf, an einer Ziegelwand montiert.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V Akku-Schnellladegerät »PLG 20 C3«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Ladestrom</strong>: max. 4,5 A</p>',
      title: "20 V Akku-Schnellladegerät »PLG 20 C3«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 14.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396589,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 615,
      recommendedNo: 10,
      recommendedYes: 481,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770025456,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Schnellladegerät »PLG 20 C3«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-4-ah-smart-akku-paps-204-b1-mit-cell-balancing/p100396628",
    canonicalUrl: "/p/parkside-performance-20-v-4-ah-smart-akku-paps-204-b1-mit-cell-balancing/p100396628",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396628_1c2c6083",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396628_43301d64",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396628",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V / 4 Ah Smart-Akku »PAPS 204 B1«, mit Cell Balancing",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485592"],
    image: "https://www.lidl.de/assets/gcpec46d3f663c44b81939c8c563886888d.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpec46d3f663c44b81939c8c563886888d.jpg",
      accessibility: "Schwarzer Akku für kabelloses Werkzeug mit roten Akzenten und Ladeanzeige",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpec46d3f663c44b81939c8c563886888d.jpg",
      "https://www.lidl.de/assets/gcpe7474006803340128057779ae312586d.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpec46d3f663c44b81939c8c563886888d.jpg",
        accessibility: "Schwarzer Akku für kabelloses Werkzeug mit roten Akzenten und Ladeanzeige",
      },
      {
        image: "https://www.lidl.de/assets/gcpe7474006803340128057779ae312586d.jpg",
        accessibility: "Schwarzer 20V Akku mit roten Knöpfen und Batteriestandsanzeige.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V / 4 Ah Smart-Akku »PAPS 204 B1«, mit Cell Balancing",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>",
      title: "20 V / 4 Ah Smart-Akku »PAPS 204 B1«, mit Cell Balancing",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 49.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396628,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.5,
      count: 11,
      recommendedNo: 1,
      recommendedYes: 10,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770015647,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 4 Ah Smart-Akku »PAPS 204 B1«, mit Cell Balancing",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100396674",
    canonicalUrl: "/p/parkside-20-v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100396674",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396674_8d9979b1",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396674_63b430b8",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396674",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["485596"],
    image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
      accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
      "https://www.lidl.de/assets/gcpe79706d2a0714d4dbcb58174e9491289.jpg",
      "https://www.lidl.de/assets/gcp91a957949deb4104a93059a7e96782fe.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
        accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
      },
      {
        image: "https://www.lidl.de/assets/gcpe79706d2a0714d4dbcb58174e9491289.jpg",
        accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
      },
      {
        image: "https://www.lidl.de/assets/gcp91a957949deb4104a93059a7e96782fe.jpg",
        accessibility: "Schwarz-roter Akku für Elektrowerkzeuge mit X20V Team Logo",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (2 Ah)</p>',
      title: "20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396674,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 103,
      recommendedNo: 3,
      recommendedYes: 99,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770025597,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-2-ah-akku-pap-202-a1-ohne-ladegeraet/p100397988",
    canonicalUrl: "/p/parkside-20-v-2-ah-akku-pap-202-a1-ohne-ladegeraet/p100397988",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100397988_a2f095a4",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100397988_519bf5ab",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100397988",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 202 A1«, ohne Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["494230"],
    image: "https://www.lidl.de/assets/gcpb00093c838724f8fb2e6f41eb8f1e2b3.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpb00093c838724f8fb2e6f41eb8f1e2b3.jpg",
      accessibility: "PARKSIDE X 20V Team 2.0Ah Lithium-Ionen-Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpb00093c838724f8fb2e6f41eb8f1e2b3.jpg",
      "https://www.lidl.de/assets/gcpda9b2efd494a4995b06212fba5c216e6.jpg",
      "https://www.lidl.de/assets/gcp54f6bd9b8e2f4e43bd48b4e723b44334.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpb00093c838724f8fb2e6f41eb8f1e2b3.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Lithium-Ionen-Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcpda9b2efd494a4995b06212fba5c216e6.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Akku in Schwarz-Rot-Design",
      },
      {
        image: "https://www.lidl.de/assets/gcp54f6bd9b8e2f4e43bd48b4e723b44334.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Akku in Schwarz-Rot-Design",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 202 A1«, ohne Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 2 Ah</p>',
      title: "20 V / 2 Ah Akku »PAP 202 A1«, ohne Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100397988,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770021984,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 2 Ah Akku »PAP 202 A1«, ohne Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    canonicalUrl: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100397995_23eadd7b",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100397995_09205bd7",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100397995",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496305"],
    image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
      "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
        accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
      },
      {
        image: "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Akku in Schwarz-Rot-Design",
      },
      {
        image: "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
        accessibility: "PARKSIDE 20V 2.0Ah Akku mit grüner Ladeanzeige",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (2 Ah)<br /> <strong>Ladestrom</strong>: 2,4 A</p>',
      title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 22.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100397995,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769986855,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1« ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    canonicalUrl: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398189_807d5a8f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398189_cf33db0b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398189",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496285"],
    image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
      "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
        accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku auf einer Holzwerkbank",
      },
      {
        image: "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>',
      title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398189,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020843,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-4-ah-smart-akku-papp-204-a1/p100398333",
    canonicalUrl: "/p/parkside-performance-20-v-4-ah-smart-akku-papp-204-a1/p100398333",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398333_cea1742f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398333_538aafaf",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398333",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V / 4 Ah Smart-Akku »PAPP 204 A1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496302"],
    image: "https://www.lidl.de/assets/gcpa85b9bdc93ca4354b3bd5c13d854b06c.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpa85b9bdc93ca4354b3bd5c13d854b06c.jpg",
      accessibility: "Parkside Performance X 20V Team 4.0Ah Akku",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpa85b9bdc93ca4354b3bd5c13d854b06c.jpg",
      "https://www.lidl.de/assets/gcp062adc02838a457fb02a74e865115958.jpg",
      "https://www.lidl.de/assets/gcp0b9a08f866c24662825ef2482e65d576.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpa85b9bdc93ca4354b3bd5c13d854b06c.jpg",
        accessibility: "Parkside Performance X 20V Team 4.0Ah Akku",
      },
      {
        image: "https://www.lidl.de/assets/gcp062adc02838a457fb02a74e865115958.jpg",
        accessibility: "Parkside Performance X 20V Team 4.0Ah Akku",
      },
      {
        image: "https://www.lidl.de/assets/gcp0b9a08f866c24662825ef2482e65d576.jpg",
        accessibility: "Parkside Performance X 20V Team 4.0Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V / 4 Ah Smart-Akku »PAPP 204 A1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>",
      title: "20 V / 4 Ah Smart-Akku »PAPP 204 A1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398333,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770024498,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 4 Ah Smart-Akku »PAPP 204 A1«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    canonicalUrl: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    category: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
    categorySecondaryPath: "0/41/4111/411118/41111812",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398778_0d5cfdc7",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398778_a8c4ff27",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398778",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["525408"],
    image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
      "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
        accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
      },
      {
        image: "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit rotem Kreuz darüber.",
      },
      {
        image: "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
        accessibility: "PARKSIDE elektrische Luftpumpe bläst eine blaue Luftmatratze auf einem Teppich auf.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
      fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Druck</strong>: max. 10,3 bar</p>',
      title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 32.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398778,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770021864,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-5-a-akku-schnellladegeraet-plg-20-c3-ohne-akku/p100399000",
    canonicalUrl: "/p/parkside-20-v-4-5-a-akku-schnellladegeraet-plg-20-c3-ohne-akku/p100399000",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100399000_5f45c6ca",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100399000_7bf48ebb",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100399000",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496303"],
    image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
      accessibility: "Parkside X20V Team Akku-Ladegerät 4.5A max.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
      "https://www.lidl.de/assets/gcp175667de0b954b47abbde5ca93aee646.jpg",
      "https://www.lidl.de/assets/gcp13ac059d93504a5992700266858d84fd.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
        accessibility: "Parkside X20V Team Akku-Ladegerät 4.5A max.",
      },
      {
        image: "https://www.lidl.de/assets/gcp175667de0b954b47abbde5ca93aee646.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp13ac059d93504a5992700266858d84fd.jpg",
        accessibility: "Schwarzes Parkside X 20V Team Akkuladegerät mit grauem Akku, grünes Licht leuchtet.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Bemessungsaufnahme</strong>: 120 W<br /> <strong>Ladestrom</strong>: max. 4,5 A</p>',
      title: "20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 14.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100399000,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770015647,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-8-ah-smart-akku-papp-208-a1/p100399718",
    canonicalUrl: "/p/parkside-performance-20-v-8-ah-smart-akku-papp-208-a1/p100399718",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100399718_3daaa80e",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100399718_8329b38d",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100399718",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496304"],
    image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
      accessibility: "PARKSIDE PERFORMANCE 8.0Ah X 20V TEAM Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
      "https://www.lidl.de/assets/gcp214a09506c7345f896466214dbc004cf.jpg",
      "https://www.lidl.de/assets/gcp9c5406d1bc7046e1a4fc3ac0685ce374.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
        accessibility: "PARKSIDE PERFORMANCE 8.0Ah X 20V TEAM Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp214a09506c7345f896466214dbc004cf.jpg",
        accessibility: "PARKSIDE X 20V Team 8.0Ah Akku mit grünem Licht, schwebend vor Betonhintergrund.",
      },
      {
        image: "https://www.lidl.de/assets/gcp9c5406d1bc7046e1a4fc3ac0685ce374.jpg",
        accessibility: "Parkside Performance X 20V Team 8.0Ah Akku, schwarz und rot.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 8 Ah</p>",
      title: "20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      endDate: "2026-02-08T23:00",
      hasStar: true,
      hasVat: true,
      price: 59.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100399718,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901257,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
    zones: {},
  },
];

export const crossGridboxResponse = [
  {
    ageRestriction: false,
    awards: [],
    brand: {
      name: "Wiha",
      url: "/q/search?q=wiha",
      id: "WIHA",
      showBrand: true,
    },
    canonicalPath: "/p/wiha-4v-akkuschrauber-zai-hause-mit-4-bits/p100345897",
    canonicalUrl: "/p/wiha-4v-akkuschrauber-zai-hause-mit-4-bits/p100345897",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkuschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111911",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100345897_021d4c13",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100345897_fcf3853d",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100345897",
    flashSales: false,
    fullTitle: "Wiha 4V Akkuschrauber »zai Hause«, mit 4 Bits",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 3,
    ians: ["401772"],
    image: "https://www.lidl.de/assets/gcpf6fc20862a9948659e00b91cab498a00.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpf6fc20862a9948659e00b91cab498a00.jpeg",
      accessibility: "Ein ZOJ Haus Akku-Schraubendreher-Set mit verschiedenen Bits und einem Ladekabel.",
    },
    isUsedProduct: false,
    imageList: ["https://www.lidl.de/assets/gcpf6fc20862a9948659e00b91cab498a00.jpeg"],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpf6fc20862a9948659e00b91cab498a00.jpeg",
        accessibility: "Ein ZOJ Haus Akku-Schraubendreher-Set mit verschiedenen Bits und einem Ladekabel.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkuschrauber",
      description:
        '<p><span style="color: #0050aa;">✓</span> 3 Kraftstufen mit schneller Einstellm&ouml;glichkeit<br /> <span style="color: #0050aa;">✓</span> LED-Anzeige f&uuml;r&nbsp;Akkustand, Drehmomentstufe,&nbsp;Laufrichtung&nbsp;<br /> <span style="color: #0050aa;">✓</span> Magnetische Bithalterung</p>',
      fullTitle: "Wiha 4V Akkuschrauber »zai Hause«, mit 4 Bits",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Akku: </strong>4 V<strong> </strong>(2 Ah)<br /> <strong>Leerlaufdrehzahl: </strong> 200 rpm<br /> <strong>Drehmoment: </strong> 1,0; 3,0; 5,0 Nm</p>",
      title: "4V Akkuschrauber »zai Hause«, mit 4 Bits",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 69.99,
        discountHasStar: false,
        fromRecommendedPrice: true,
        hideBargainHint: false,
        percentageDiscount: 10,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      price: 62.9,
      recommendedPrice: 69.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100345897,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 0,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901251,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "4V Akkuschrauber »zai Hause«, mit 4 Bits",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-saebelsaegeblaetter-pfsz-3-b1-3-teilig/p100387450",
    canonicalUrl: "/p/parkside-saebelsaegeblaetter-pfsz-3-b1-3-teilig/p100387450",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Sägeblätter",
    categorySecondaryPath: "0/41/4111/411119/41111991",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100387450_17da4fe0",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100387450_8e33be2a",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100387450",
    flashSales: false,
    fullTitle: "PARKSIDE® Säbelsägeblätter »PFSZ 3 B1«, 3-teilig",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["471927"],
    image: "https://www.lidl.de/assets/gcp4ca478f4bd7a417192b4bd5e5074fa84.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp4ca478f4bd7a417192b4bd5e5074fa84.jpg",
      accessibility: "Parkside Sägeblätter: Holz, Metall und flexibles Metall.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp4ca478f4bd7a417192b4bd5e5074fa84.jpg",
      "https://www.lidl.de/assets/gcp64657d4eb9044049b6df1e6c84cd7d92.jpg",
      "https://www.lidl.de/assets/gcpef0f2de7fdec4db3affdb6cd23c19a7e.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp4ca478f4bd7a417192b4bd5e5074fa84.jpg",
        accessibility: "Parkside Sägeblätter: Holz, Metall und flexibles Metall.",
      },
      {
        image: "https://www.lidl.de/assets/gcp64657d4eb9044049b6df1e6c84cd7d92.jpg",
        accessibility: "Parkside flexible Metall-Sägeblätter.",
      },
      {
        image: "https://www.lidl.de/assets/gcpef0f2de7fdec4db3affdb6cd23c19a7e.jpg",
        accessibility: "Parkside Sägeblätter: Flexibles Metall, sauberes Holz, schnell Holz & Metall.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Sägeblätter",
      fullTitle: "PARKSIDE® Säbelsägeblätter »PFSZ 3 B1«, 3-teilig",
      moreDetails: "Weitere Produktdetails",
      title: "Säbelsägeblätter »PFSZ 3 B1«, 3-teilig",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 6.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100387450,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 90,
      recommendedNo: 1,
      recommendedYes: 84,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1769962083,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Säbelsägeblätter »PFSZ 3 B1«, 3-teilig",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-rasentrimmer-part-20-li-a1-ohne-akku-und-ladegeraet/p100388469",
    canonicalUrl: "/p/parkside-20-v-akku-rasentrimmer-part-20-li-a1-ohne-akku-und-ladegeraet/p100388469",
    category: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Rasentrimmer",
    categorySecondaryPath: "0/41/4110/411012/41101220",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100388469_b38acb42",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100388469_7ae2089b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100388469",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Rasentrimmer »PART 20-Li A1«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["472041"],
    image: "https://www.lidl.de/assets/gcp812c5a8b3c00459aadeff4a353c112a5.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp812c5a8b3c00459aadeff4a353c112a5.jpg",
      accessibility: "Parkside Grasschneider: elektrisches Gartengerät.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp812c5a8b3c00459aadeff4a353c112a5.jpg",
      "https://www.lidl.de/assets/gcp4cda2a089fd145a29d9f5e3e29519f70.jpg",
      "https://www.lidl.de/assets/gcp7191bf30d91d4b8aad27c2c184689a85.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp812c5a8b3c00459aadeff4a353c112a5.jpg",
        accessibility: "Parkside Grasschneider: elektrisches Gartengerät.",
      },
      {
        image: "https://www.lidl.de/assets/gcp4cda2a089fd145a29d9f5e3e29519f70.jpg",
        accessibility: "Parkside X 20V Team Ladegerät und Akku verboten.",
      },
      {
        image: "https://www.lidl.de/assets/gcp7191bf30d91d4b8aad27c2c184689a85.jpg",
        accessibility: "Ein Mann verwendet eine Parkside-Freischneider zum Trimmen von Rasen und Büschen.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Rasentrimmer",
      fullTitle: "PARKSIDE® 20 V Akku-Rasentrimmer »PART 20-Li A1«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      title: "20 V Akku-Rasentrimmer »PART 20-Li A1«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Gartengeräte & Gartenwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1212",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100388469,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.3,
      count: 348,
      recommendedNo: 48,
      recommendedYes: 282,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770027293,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Rasentrimmer »PART 20-Li A1«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-bohrhammer-pabh-20-li-d4-ohne-akku-und-ladegeraet/p100391182",
    canonicalUrl: "/p/parkside-20-v-akku-bohrhammer-pabh-20-li-d4-ohne-akku-und-ladegeraet/p100391182",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrhammer",
    categorySecondaryPath: "0/41/4111/411119/41111996",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100391182_930964f8",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100391182_2bc8ce6b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100391182",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Bohrhammer »PABH 20-Li D4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["479362"],
    image: "https://www.lidl.de/assets/gcp6f902adecb4c494db7993d636bab09ec.png",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp6f902adecb4c494db7993d636bab09ec.png",
      accessibility: "Parkside X20V Team Akku-Bohrhammer mit Bohrer.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp6f902adecb4c494db7993d636bab09ec.png",
      "https://www.lidl.de/assets/gcp7391ac7d72a041f794e1633ed3fd4766.jpg",
      "https://www.lidl.de/assets/gcpc763f909898345919cc9e028b218d5a4.png",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp6f902adecb4c494db7993d636bab09ec.png",
        accessibility: "Parkside X20V Team Akku-Bohrhammer mit Bohrer.",
      },
      {
        image: "https://www.lidl.de/assets/gcp7391ac7d72a041f794e1633ed3fd4766.jpg",
        accessibility: "Das Parkside X20V Team Akkuladegerät ist verboten.",
      },
      {
        image: "https://www.lidl.de/assets/gcpc763f909898345919cc9e028b218d5a4.png",
        accessibility:
          "Ein Arbeiter verwendet einen Parkside Akku-Bohrhammer, um ein Loch in eine weiße Ziegelwand zu bohren.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrhammer",
      description:
        '<p><span style="color: #bb251f;">Akku und Ladeger&auml;t nicht im Lieferumfang enthalten!</span></p> <p><span style="color: #bb251f;"><a href="https://www.lidl.de/c/parkside-x-20-v-team/a10007371#10023133" target="_blank" title="Parkside X 20 V Team">Hier gleich mitbestellen ➠</a></span></p>',
      fullTitle: "PARKSIDE® 20 V Akku-Bohrhammer »PABH 20-Li D4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p> Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong> <br /> <strong>Schlagenergie</strong>: 1 Joule<br /><strong>Schlagzahl</strong>: 0–5000 min⁻¹</p>',
      title: "20 V Akku-Bohrhammer »PABH 20-Li D4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100391182,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 70,
      recommendedNo: 1,
      recommendedYes: 66,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770015646,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395394",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Bohrhammer »PABH 20-Li D4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20v-akku-drehschlagschrauber-pdssa-20-li-b2-ohne-akku-und-ladegeraet/p100391222",
    canonicalUrl: "/p/parkside-20v-akku-drehschlagschrauber-pdssa-20-li-b2-ohne-akku-und-ladegeraet/p100391222",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111998",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100391222_1d240314",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100391222_d8376322",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100391222",
    flashSales: false,
    fullTitle: "PARKSIDE® 20V Akku-Drehschlagschrauber »PDSSA 20-Li B2«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["479364"],
    image: "https://www.lidl.de/assets/gcpa1fd2d928b704d2b82951676c7c723d4.png",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpa1fd2d928b704d2b82951676c7c723d4.png",
      accessibility: "",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpa1fd2d928b704d2b82951676c7c723d4.png",
      "https://www.lidl.de/assets/gcpe1b6e3e8f9b44d8ca236f27419c27e5a.png",
      "https://www.lidl.de/assets/gcpfead38ee89344a4a821ea29b4b023363.png",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpa1fd2d928b704d2b82951676c7c723d4.png",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcpe1b6e3e8f9b44d8ca236f27419c27e5a.png",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcpfead38ee89344a4a821ea29b4b023363.png",
        accessibility: "",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
      description:
        '<p><span style="color: #bb251f;">Akku und Ladeger&auml;t nicht im Lieferumfang enthalten!<br /> <a href="https://www.lidl.de/c/parkside-x-20-v-team/a10007371#10023133" target="_blank" title="Parkside X 20 V Team">Hier gleich mitbestellen ➠</a></span></p> <p>&nbsp;</p>',
      fullTitle: "PARKSIDE® 20V Akku-Drehschlagschrauber »PDSSA 20-Li B2«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Schlagzahl</strong>:&nbsp;0-3600 min⁻&sup1;<br /> <strong>Drehmoment</strong>:&nbsp;180 Nm</p>',
      title: "20V Akku-Drehschlagschrauber »PDSSA 20-Li B2«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100391222,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.4,
      count: 70,
      recommendedNo: 6,
      recommendedYes: 61,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1769901255,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100391698",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20V Akku-Drehschlagschrauber »PDSSA 20-Li B2«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/98aac8ed27781c21fa3146014d755a8b.jpeg",
      name: "Güde",
      url: "https://www.lidl.de/q/brand/guede/b2541",
      id: "GÜDE",
      showBrand: true,
    },
    canonicalPath: "/p/guede-kehrmaschine-gkm-700-klappbarer-fahrbuegel/p100394777",
    canonicalUrl: "/p/guede-kehrmaschine-gkm-700-klappbarer-fahrbuegel/p100394777",
    category: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Weitere Gartengeräte",
    categorySecondaryPath: "0/41/4110/411012/41101218",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100394777_0a16d919",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100394777_565088fe",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100394777",
    flashSales: false,
    fullTitle: "Güde Kehrmaschine »GKM 700«, klappbarer Fahrbügel",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["100394777"],
    image: "https://www.lidl.de/assets/gcpe517f839624244e5a0bdd9a5e0d53e83.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe517f839624244e5a0bdd9a5e0d53e83.jpg",
      accessibility: "",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe517f839624244e5a0bdd9a5e0d53e83.jpg",
      "https://www.lidl.de/assets/gcpcb7fcfea5af143e4a12c23970b49f7e3.jpg",
      "https://www.lidl.de/assets/gcp2ac8821b8ac347d0a2216ebb54fd9aa0.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe517f839624244e5a0bdd9a5e0d53e83.jpg",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcpcb7fcfea5af143e4a12c23970b49f7e3.jpg",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcp2ac8821b8ac347d0a2216ebb54fd9aa0.jpg",
        accessibility: "",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Garten & Grillen/Gartengeräte & Gartenmaschinen/Weitere Gartengeräte",
      fullTitle: "Güde Kehrmaschine »GKM 700«, klappbarer Fahrbügel",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Kehrbreite</strong>: ca. 70 cm<br /> <strong>Antriebsart</strong>: manuell</p>",
      title: "Kehrmaschine »GKM 700«, klappbarer Fahrbügel",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Gartengeräte & Gartenwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1212",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 129,
        discountHasStar: false,
        fromRecommendedPrice: true,
        hideBargainHint: false,
        percentageDiscount: 39,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      price: 77.99,
      recommendedPrice: 129,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100394777,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770013429,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Kehrmaschine »GKM 700«, klappbarer Fahrbügel",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-winkelschleifer-pwsa-20-li-d4-mit-akku-und-ladegeraet/p100395204",
    canonicalUrl: "/p/parkside-20-v-akku-winkelschleifer-pwsa-20-li-d4-mit-akku-und-ladegeraet/p100395204",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Winkelschleifer & Zubehör",
    categorySecondaryPath: "0/41/4111/411119/41111926",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100395204_beb029d1",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100395204_5df50905",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100395204",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Winkelschleifer »PWSA 20-Li D4«, mit Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["487756"],
    image: "https://www.lidl.de/assets/gcp7ad1b6d1982e4b788df90e69b10cea04.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp7ad1b6d1982e4b788df90e69b10cea04.jpg",
      accessibility: "Ein grüner und schwarzer Parkside Akku-Winkelschleifer mit Trennscheibe.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp7ad1b6d1982e4b788df90e69b10cea04.jpg",
      "https://www.lidl.de/assets/gcpf348f2d9a72a492c847098fd30780635.jpg",
      "https://www.lidl.de/assets/gcpb019b37d9347486593d1ee9fc328b755.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp7ad1b6d1982e4b788df90e69b10cea04.jpg",
        accessibility: "Ein grüner und schwarzer Parkside Akku-Winkelschleifer mit Trennscheibe.",
      },
      {
        image: "https://www.lidl.de/assets/gcpf348f2d9a72a492c847098fd30780635.jpg",
        accessibility: "Parkside Akku-Winkelschleifer schneidet ein Metallrohr auf einer Holzwerkbank.",
      },
      {
        image: "https://www.lidl.de/assets/gcpb019b37d9347486593d1ee9fc328b755.jpg",
        accessibility: "Parkside Akku-Winkelschleifer mit Akku und Trennscheibe",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Winkelschleifer & Zubehör",
      fullTitle: "PARKSIDE® 20 V Akku-Winkelschleifer »PWSA 20-Li D4«, mit Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (4 Ah)<br /> <strong>Leerlaufdrehzahl</strong>: 2500&ndash;11500 min<sup>-1</sup></p>',
      title: "20 V Akku-Winkelschleifer »PWSA 20-Li D4«, mit Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 67.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100395204,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 102,
      recommendedNo: 4,
      recommendedYes: 94,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770024140,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1764370800,
    title: "20 V Akku-Winkelschleifer »PWSA 20-Li D4«, mit Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-12-a-smart-akku-ladegeraet-plgs-2012-a1-ohne-akku/p100395251",
    canonicalUrl: "/p/parkside-performance-20-v-12-a-smart-akku-ladegeraet-plgs-2012-a1-ohne-akku/p100395251",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100395251_65224dfc",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100395251_7dddcc17",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100395251",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V / 12 A Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["505114"],
    image: "https://www.lidl.de/assets/gcp851c300fb5e245028c5b6140aa5589d5.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp851c300fb5e245028c5b6140aa5589d5.jpg",
      accessibility: "Ein Parkside Smart-Akkuladegerät mit Akku, das Ladezeiten und Akkustatus anzeigt.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp851c300fb5e245028c5b6140aa5589d5.jpg",
      "https://www.lidl.de/assets/gcp60f0cf8d15014db28e1881a2a2933cb6.jpg",
      "https://www.lidl.de/assets/gcp710e2532ec39459eb981ee0c119b38ca.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp851c300fb5e245028c5b6140aa5589d5.jpg",
        accessibility: "Ein Parkside Smart-Akkuladegerät mit Akku, das Ladezeiten und Akkustatus anzeigt.",
      },
      {
        image: "https://www.lidl.de/assets/gcp60f0cf8d15014db28e1881a2a2933cb6.jpg",
        accessibility:
          "Ein Parkside X20V Team Akku wird auf einem Parkside Ladegerät geladen, mit einem gelben Kreuz darüber.",
      },
      {
        image: "https://www.lidl.de/assets/gcp710e2532ec39459eb981ee0c119b38ca.jpg",
        accessibility: "Parkside X 20V Team Akkuladegerät mit angeschlossenem Akku an einer Ziegelwand.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V / 12 A Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Bemessungsaufnahme</strong>: 300 W<br /> <strong>Ladestrom</strong>: max. 12 A</p>",
      title: "20 V / 12 A Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100395251,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 190,
      recommendedNo: 10,
      recommendedYes: 166,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901251,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 12 A Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-akku-saebelsaege-pssap-20-li-e6-ohne-akku-und-ladegeraet/p100396290",
    canonicalUrl: "/p/parkside-performance-20-v-akku-saebelsaege-pssap-20-li-e6-ohne-akku-und-ladegeraet/p100396290",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Stichsägen",
    categorySecondaryPath: "0/41/4111/411119/41111920",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396290_1b539cbc",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396290_ff761d62",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396290",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Säbelsäge »PSSAP 20-Li E6«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485608"],
    image: "https://www.lidl.de/assets/gcpc26d316962f043d3b37a8b259072196c.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpc26d316962f043d3b37a8b259072196c.jpg",
      accessibility: "Eine schwarze Akku-Säbelsäge mit Holzsägeblatt und abnehmbarem Akku.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpc26d316962f043d3b37a8b259072196c.jpg",
      "https://www.lidl.de/assets/gcp552d872c847a46ea93b60e8f2436d4e2.jpg",
      "https://www.lidl.de/assets/gcp6352c9288c584ddcabb2255caa632265.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpc26d316962f043d3b37a8b259072196c.jpg",
        accessibility: "Eine schwarze Akku-Säbelsäge mit Holzsägeblatt und abnehmbarem Akku.",
      },
      {
        image: "https://www.lidl.de/assets/gcp552d872c847a46ea93b60e8f2436d4e2.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcp6352c9288c584ddcabb2255caa632265.jpg",
        accessibility: "Eine Person sägt ein Holzbrett mit einer Akku-Säbelsäge.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Stichsägen",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Säbelsäge »PSSAP 20-Li E6«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufhubzahl</strong>: 0&ndash;3000 min⁻&sup1;<br /> <strong>Hubl&auml;nge</strong>: ca. 22 mm</p>",
      title: "20 V Akku-Säbelsäge »PSSAP 20-Li E6«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 67.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396290,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.9,
      count: 28,
      recommendedNo: 0,
      recommendedYes: 27,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1769901254,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Säbelsäge »PSSAP 20-Li E6«, ohne Akku und Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-akku-stichsaege-psspa-20-li-f4-ohne-akku-und-ladegeraet/p100396315",
    canonicalUrl: "/p/parkside-performance-20-v-akku-stichsaege-psspa-20-li-f4-ohne-akku-und-ladegeraet/p100396315",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Stichsägen",
    categorySecondaryPath: "0/41/4111/411119/41111920",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396315_8049ad1f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396315_107ee5fb",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396315",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Stichsäge »PSSPA 20-Li F4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485607"],
    image: "https://www.lidl.de/assets/gcpf12838703ddd4134995a8d0a5fe1b0cb.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpf12838703ddd4134995a8d0a5fe1b0cb.jpg",
      accessibility: "Akku-Stichsäge, schwarz und silber, mit einem Holzsägeblatt.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpf12838703ddd4134995a8d0a5fe1b0cb.jpg",
      "https://www.lidl.de/assets/gcp3b449180b38d46d7ba3c0c05e33b258d.jpg",
      "https://www.lidl.de/assets/gcpd74c078eea8a43d6836415e8bc4fa748.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpf12838703ddd4134995a8d0a5fe1b0cb.jpg",
        accessibility: "Akku-Stichsäge, schwarz und silber, mit einem Holzsägeblatt.",
      },
      {
        image: "https://www.lidl.de/assets/gcp3b449180b38d46d7ba3c0c05e33b258d.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcpd74c078eea8a43d6836415e8bc4fa748.jpg",
        accessibility: "Eine Person benutzt eine Stichsäge, um ein Holzbrett zu schneiden.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Stichsägen",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Stichsäge »PSSPA 20-Li F4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufhubzahl</strong>: 800&ndash;3800 min<sup>-1</sup><br /> <strong>Hubl&auml;nge</strong>: ca. 26 mm</p>",
      title: "20 V Akku-Stichsäge »PSSPA 20-Li F4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 59.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396315,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.2,
      count: 23,
      recommendedNo: 4,
      recommendedYes: 18,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901255,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Akku-Stichsäge »PSSPA 20-Li F4«, ohne Akku und Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-smart-akku-ladegeraet-plgs-2012-a1-ohne-akku/p100396382",
    canonicalUrl: "/p/parkside-performance-20-v-smart-akku-ladegeraet-plgs-2012-a1-ohne-akku/p100396382",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396382_5c1be609",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396382_ee573a36",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396382",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485611"],
    image: "https://www.lidl.de/assets/gcpdfbe6cb147d14ff9b0d25a22ef7be1fb.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpdfbe6cb147d14ff9b0d25a22ef7be1fb.jpg",
      accessibility: "Akkuladegerät mit abnehmbarem Akku, mit einem gelben X darauf.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpdfbe6cb147d14ff9b0d25a22ef7be1fb.jpg",
      "https://www.lidl.de/assets/gcp245d3aacf8d04864a132fe6cf9100498.jpg",
      "https://www.lidl.de/assets/gcpb62fed1da41e44a2bc440d30aa636c55.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpdfbe6cb147d14ff9b0d25a22ef7be1fb.jpg",
        accessibility: "Akkuladegerät mit abnehmbarem Akku, mit einem gelben X darauf.",
      },
      {
        image: "https://www.lidl.de/assets/gcp245d3aacf8d04864a132fe6cf9100498.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcpb62fed1da41e44a2bc440d30aa636c55.jpg",
        accessibility: "Wandmontiertes Akkuladegerät mit angeschlossenem Elektrowerkzeugakku.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Bemessungsaufnahme</strong>: 300 W<br /> <strong>Ladestrom</strong>: max. 12 A</p>",
      title: "20 V Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396382,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 186,
      recommendedNo: 10,
      recommendedYes: 161,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901256,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V Smart-Akku-Ladegerät »PLGS 2012 A1«, ohne Akku",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath:
      "/p/parkside-performance-20-v-akku-drehschlagschrauber-pdssap-20-li-d3-ohne-akku-und-ladegeraet/p100396622",
    canonicalUrl:
      "/p/parkside-performance-20-v-akku-drehschlagschrauber-pdssap-20-li-d3-ohne-akku-und-ladegeraet/p100396622",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111998",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396622_312393e7",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396622_3ef34215",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396622",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Drehschlagschrauber »PDSSAP 20-Li D3«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485602"],
    image: "https://www.lidl.de/assets/gcpc74bdaaf4f87411b993aebfb40cf59e4.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpc74bdaaf4f87411b993aebfb40cf59e4.jpg",
      accessibility: "Akku-Schlagschrauber mit Akku, auf weißem Hintergrund",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpc74bdaaf4f87411b993aebfb40cf59e4.jpg",
      "https://www.lidl.de/assets/gcpe44ad7f1d7bd42f0aa5eae6a41029de3.jpg",
      "https://www.lidl.de/assets/gcp78d95fc92133472cb0a0d71e23ca67f8.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpc74bdaaf4f87411b993aebfb40cf59e4.jpg",
        accessibility: "Akku-Schlagschrauber mit Akku, auf weißem Hintergrund",
      },
      {
        image: "https://www.lidl.de/assets/gcpe44ad7f1d7bd42f0aa5eae6a41029de3.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcp78d95fc92133472cb0a0d71e23ca67f8.jpg",
        accessibility:
          "Eine behandschuhte Hand hält einen Akku-Schlagschrauber, der eine Schraube in eine Metallschiene auf einem Holztisch dreht.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Drehschlagschrauber",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Drehschlagschrauber »PDSSAP 20-Li D3«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Schlagzahl</strong>: 0&ndash;4300 min<sup>-1</sup><br /> <strong>Drehmoment</strong>: max. 226 Nm</p>",
      title: "20 V Akku-Drehschlagschrauber »PDSSAP 20-Li D3«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 59.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396622,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.3,
      count: 23,
      recommendedNo: 3,
      recommendedYes: 18,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770024498,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1764975600,
    title: "20 V Akku-Drehschlagschrauber »PDSSAP 20-Li D3«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-akku-bohrschrauber-pabsp-20-li-c4-ohne-akku-und-ladegeraet/p100396678",
    canonicalUrl: "/p/parkside-performance-20-v-akku-bohrschrauber-pabsp-20-li-c4-ohne-akku-und-ladegeraet/p100396678",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111997",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396678_3403267a",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396678_e93ee1e9",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396678",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485609"],
    image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
      accessibility: "Akku-Bohrschrauber mit bürstenlosem Motor und 60 Nm Drehmoment",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
      "https://www.lidl.de/assets/gcpc1d4be45ff6e4c0c9ec9e3cbc616fbc2.jpg",
      "https://www.lidl.de/assets/gcp066714c18ad2448ea9d15c394ca262bd.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
        accessibility: "Akku-Bohrschrauber mit bürstenlosem Motor und 60 Nm Drehmoment",
      },
      {
        image: "https://www.lidl.de/assets/gcpc1d4be45ff6e4c0c9ec9e3cbc616fbc2.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcp066714c18ad2448ea9d15c394ca262bd.jpg",
        accessibility: "Bürstenloser Akku-Bohrschrauber mit 4 Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufdrehzahl</strong>: max. 0&ndash;2000 min⁻&sup1;<br /> <strong>Drehmoment</strong>: max. 60 Nm</p>",
      title: "20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 54.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 27,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 54.99,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396678,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.5,
      count: 27,
      recommendedNo: 3,
      recommendedYes: 23,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770019710,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "auch in der Filiale von 09.02. - 14.02.",
            type: "ALSO_IN_STORE_FROM_FUTURE_DATE_RANGE",
          },
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeStartDate: 1770591600,
    storeEndDate: 1771023600,
    title: "20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-handkreissaege-phksa-20-li-c4-ohne-akku-und-ladegeraet/p100398022",
    canonicalUrl: "/p/parkside-20-v-akku-handkreissaege-phksa-20-li-c4-ohne-akku-und-ladegeraet/p100398022",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Sägen & Zubehör",
    categorySecondaryPath: "0/41/4111/411119/41111922",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398022_2871ccf8",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398022_1e6a6986",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398022",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / Akku-Handkreissäge »PHKSA 20-Li C4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496282"],
    image: "https://www.lidl.de/assets/gcpbca7622412fa4911a7cec0fc1c8285d9.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpbca7622412fa4911a7cec0fc1c8285d9.jpg",
      accessibility: "PARKSIDE Akku-Kreissäge mit 20V Akku, grau und grün mit roten Akzenten",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpbca7622412fa4911a7cec0fc1c8285d9.jpg",
      "https://www.lidl.de/assets/gcp59ac97c5fc274618b0ff12d05de4c810.jpg",
      "https://www.lidl.de/assets/gcp0fc5c64d31c846f6b046da335441c8bf.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpbca7622412fa4911a7cec0fc1c8285d9.jpg",
        accessibility: "PARKSIDE Akku-Kreissäge mit 20V Akku, grau und grün mit roten Akzenten",
      },
      {
        image: "https://www.lidl.de/assets/gcp59ac97c5fc274618b0ff12d05de4c810.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp0fc5c64d31c846f6b046da335441c8bf.jpg",
        accessibility: "Hände mit Handschuhen verwenden eine PARKSIDE Kreissäge, um ein Holzbrett zu schneiden.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Sägen & Zubehör",
      fullTitle: "PARKSIDE® 20 V / Akku-Handkreissäge »PHKSA 20-Li C4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Leerlaufdrehzahl</strong>: 3800 min<sup>-1</sup><br /> <strong>S&auml;geblatt-&Oslash;</strong>: ca. &Oslash; 16 cm x 1,6 cm</p>',
      title: "20 V / Akku-Handkreissäge »PHKSA 20-Li C4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 54.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398022,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 3,
      recommendedNo: 0,
      recommendedYes: 3,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020843,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / Akku-Handkreissäge »PHKSA 20-Li C4«, ohne Akku und Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    canonicalUrl: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398189_807d5a8f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398189_cf33db0b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398189",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496285"],
    image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
      "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
        accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku auf einer Holzwerkbank",
      },
      {
        image: "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>',
      title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398189,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020843,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-5-a-akku-schnellladegeraet-plg-20-c3-ohne-akku/p100399000",
    canonicalUrl: "/p/parkside-20-v-4-5-a-akku-schnellladegeraet-plg-20-c3-ohne-akku/p100399000",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100399000_5f45c6ca",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100399000_7bf48ebb",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100399000",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496303"],
    image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
      accessibility: "Parkside X20V Team Akku-Ladegerät 4.5A max.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
      "https://www.lidl.de/assets/gcp175667de0b954b47abbde5ca93aee646.jpg",
      "https://www.lidl.de/assets/gcp13ac059d93504a5992700266858d84fd.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpdedaa98f765d46f7a33defdb2265f68b.jpg",
        accessibility: "Parkside X20V Team Akku-Ladegerät 4.5A max.",
      },
      {
        image: "https://www.lidl.de/assets/gcp175667de0b954b47abbde5ca93aee646.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp13ac059d93504a5992700266858d84fd.jpg",
        accessibility: "Schwarzes Parkside X 20V Team Akkuladegerät mit grauem Akku, grünes Licht leuchtet.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Bemessungsaufnahme</strong>: 120 W<br /> <strong>Ladestrom</strong>: max. 4,5 A</p>',
      title: "20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 14.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100399000,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770015647,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 4,5 A Akku-Schnellladegerät »PLG 20 C3«, ohne Akku",
    zones: {},
  },
];

export const categoryGridboxResponse = [
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-12-v-akku-feinbohrschleifer-pfbs-12-c6-mit-akku-ohne-netzteil/p100359881",
    canonicalUrl: "/p/parkside-12-v-akku-feinbohrschleifer-pfbs-12-c6-mit-akku-ohne-netzteil/p100359881",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Schleifmaschinen & Zubehör/Bandschleifer",
    categorySecondaryPath: "0/41/4111/411119/41111925/411119251",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100359881_ef77ec8c",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100359881_977d5e6d",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100359881",
    flashSales: false,
    fullTitle: "PARKSIDE® 12 V Akku- Feinbohrschleifer »PFBS 12 C6«, mit Akku ohne Netzteil",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["499890"],
    image: "https://www.lidl.de/assets/gcpcf5a2185c3e647b8a5ec23e87e16b3ad.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpcf5a2185c3e647b8a5ec23e87e16b3ad.jpeg",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpcf5a2185c3e647b8a5ec23e87e16b3ad.jpeg",
      "https://www.lidl.de/assets/gcp079aea7319d54c95aec52f9c6c91cb22.jpeg",
      "https://www.lidl.de/assets/gcp0b669be975ff4ee79408d6355aacc858.jpeg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpcf5a2185c3e647b8a5ec23e87e16b3ad.jpeg",
      },
      {
        image: "https://www.lidl.de/assets/gcp079aea7319d54c95aec52f9c6c91cb22.jpeg",
      },
      {
        image: "https://www.lidl.de/assets/gcp0b669be975ff4ee79408d6355aacc858.jpeg",
      },
    ],
    keyfacts: {
      analyticsCategory:
        "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Schleifmaschinen & Zubehör/Bandschleifer",
      description:
        '<p><span style="color: #0050aa;">✓</span> Mit rutschhemmender Softgrip-Ausstattung<br /> <span style="color: #0050aa;">✓</span> Stufenlos einstellbare Drehzahl<br /> <span style="color: #0050aa;">✓</span> In praktischer Aufbewahrungsbox</p>',
      fullTitle: "PARKSIDE® 12 V Akku- Feinbohrschleifer »PFBS 12 C6«, mit Akku ohne Netzteil",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Akku: </strong> 12 V<br /> <strong>Leerlaufdrehzahl:</strong> 5.000 - 25.000 1/min</p>",
      title: "12 V Akku- Feinbohrschleifer »PFBS 12 C6«, mit Akku ohne Netzteil",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    mouseoverImage: "https://www.lidl.de/assets/gcp079aea7319d54c95aec52f9c6c91cb22.jpeg",
    mouseoverImage_V1: {
      image: "https://www.lidl.de/assets/gcp079aea7319d54c95aec52f9c6c91cb22.jpeg",
    },
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 34.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 48,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 34.99,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100359881,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.2,
      count: 89,
      recommendedNo: 16,
      recommendedYes: 70,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770026637,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Parkside Category",
              value: "Werkstatt",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 9001,
          name: "Parkside Category",
          version: "7",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "12 V Akku- Feinbohrschleifer »PFBS 12 C6«, mit Akku ohne Netzteil ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-bohrer-und-bit-set-pbb-4-c2-sortiert-verpackt/p100366673",
    canonicalUrl: "/p/parkside-bohrer-und-bit-set-pbb-4-c2-sortiert-verpackt/p100366673",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
    categorySecondaryPath: "0/41/4111/411119/41111988",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100366673_cac9b736",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100366673_857f1b48",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100366673",
    flashSales: false,
    fullTitle: "PARKSIDE® Bohrer- und Bit-Set »PBB 4 C2«, sortiert verpackt",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["427548"],
    image: "https://www.lidl.de/assets/gcp9f9ca3d1ce834a5aa742894ab0e97e37.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp9f9ca3d1ce834a5aa742894ab0e97e37.jpeg",
      accessibility:
        "Ein Satz mit verschiedenen Bohrertypen, darunter Schraubendreherbits, Holzbohrer und Steinbohrer.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp9f9ca3d1ce834a5aa742894ab0e97e37.jpeg",
      "https://www.lidl.de/assets/gcpc33c30fc69324462877f89618a95771a.jpeg",
      "https://www.lidl.de/assets/gcpa8fcba10abf7452aa0462ff5d33f4d1f.jpeg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp9f9ca3d1ce834a5aa742894ab0e97e37.jpeg",
        accessibility:
          "Ein Satz mit verschiedenen Bohrertypen, darunter Schraubendreherbits, Holzbohrer und Steinbohrer.",
      },
      {
        image: "https://www.lidl.de/assets/gcpc33c30fc69324462877f89618a95771a.jpeg",
        accessibility: "Ein Satz Schraubendreher mit verschiedenen Bit-Typen in einer grünen Aufbewahrungsbox.",
      },
      {
        image: "https://www.lidl.de/assets/gcpa8fcba10abf7452aa0462ff5d33f4d1f.jpeg",
        accessibility:
          "Ein Satz Schraubendreher mit verschiedenen Bits und Verlängerungen in einer grünen Aufbewahrungsbox.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
      description:
        '<p><span style="color: #0050aa;">✓</span> Sortiert verpackt in Kunststoffbox<br /> <span style="color: #0050aa;">✓</span> Boxverschluss mit Einrastpunkt</p>',
      fullTitle: "PARKSIDE® Bohrer- und Bit-Set »PBB 4 C2«, sortiert verpackt",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<p><strong>Set: </strong> 15- / 37-teilig</p>",
      title: "Bohrer- und Bit-Set »PBB 4 C2«, sortiert verpackt",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    mouseoverImage: "https://www.lidl.de/assets/gcpa8fcba10abf7452aa0462ff5d33f4d1f.jpeg",
    mouseoverImage_V1: {
      image: "https://www.lidl.de/assets/gcpa8fcba10abf7452aa0462ff5d33f4d1f.jpeg",
      accessibility:
        "Ein Satz Schraubendreher mit verschiedenen Bits und Verlängerungen in einer grünen Aufbewahrungsbox.",
    },
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 8.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        percentageDiscount: 66,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 8.99,
      price: 2.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100366673,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.7,
      count: 34,
      recommendedNo: 2,
      recommendedYes: 32,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770027290,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Bohrer- und Bit-Set »PBB 4 C2«, sortiert verpackt",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-12-v-2-5-ah-akku-papk-12-2-5-a1-und-ladegeraet-plgk-12-6-0-a1/p100379105",
    canonicalUrl: "/p/parkside-performance-12-v-2-5-ah-akku-papk-12-2-5-a1-und-ladegeraet-plgk-12-6-0-a1/p100379105",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100379105_60fe1211",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100379105_4a1c4778",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100379105",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 12 V / 2,5 Ah Akku »PAPK 12 2.5 A1« und Ladegerät »PLGK 12 6.0 A1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["449981"],
    image: "https://www.lidl.de/assets/gcp3cf4d4a8e833493b9fa0ef3110667bf7.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3cf4d4a8e833493b9fa0ef3110667bf7.jpeg",
      accessibility: "Ein schwarzes Ladegerät für einen 2,5-Ah-Akku von Worksite.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3cf4d4a8e833493b9fa0ef3110667bf7.jpeg",
      "https://www.lidl.de/assets/gcpae7935357be54280b33b7aa74254ab8d.jpeg",
      "https://www.lidl.de/assets/gcp7bff480028924341be567994472d532f.jpeg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3cf4d4a8e833493b9fa0ef3110667bf7.jpeg",
        accessibility: "Ein schwarzes Ladegerät für einen 2,5-Ah-Akku von Worksite.",
      },
      {
        image: "https://www.lidl.de/assets/gcpae7935357be54280b33b7aa74254ab8d.jpeg",
        accessibility: "Ein schwarzes Parkside Ladegerät mit einem schwarzen Kabel.",
      },
      {
        image: "https://www.lidl.de/assets/gcp7bff480028924341be567994472d532f.jpeg",
        accessibility: "Ein schwarzer Xizlteam Akku mit 2,5 Ah und roten Knöpfen.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      description:
        '<p><strong>Im Vergleich zum Akku PAPK 12 A3 (12 V / 2 Ah):</strong><br /> <span style="color: #0050aa;">✓ </span>25 % h&ouml;here Kapazit&auml;t<br /> <strong>Im Vergleich zum Ladeger&auml;t PLGK 12 A3:</strong><br /> <span style="color: #0050aa;">✓ </span>bis zu 150 % h&ouml;herer Ladestrom</p>',
      fullTitle: "PARKSIDE PERFORMANCE® 12 V / 2,5 Ah Akku »PAPK 12 2.5 A1« und Ladegerät »PLGK 12 6.0 A1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <span style="color: #226456;"><strong>PARKSIDE X 12 V Team</strong></span><br /> <strong>Akku-Spannung: </strong> 12 V<br /> <strong>Akku-Kapazit&auml;t: </strong> 2,5 Ah</p>',
      title: "12 V / 2,5 Ah Akku »PAPK 12 2.5 A1« und Ladegerät »PLGK 12 6.0 A1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 27.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100379105,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 38,
      recommendedNo: 3,
      recommendedYes: 32,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770016364,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1727474400,
    title: "12 V / 2,5 Ah Akku »PAPK 12 2.5 A1« und Ladegerät »PLGK 12 6.0 A1«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-bohrer-set/p100381667",
    canonicalUrl: "/p/parkside-bohrer-set/p100381667",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
    categorySecondaryPath: "0/41/4111/411119/41111988",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100381667_59f9e60a",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100381667_6a578f08",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100381667",
    flashSales: false,
    fullTitle: "PARKSIDE® Bohrer-Set",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["457942"],
    image: "https://www.lidl.de/assets/gcpe9cc4ee7091b423db0f91bbe2b0b1908.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe9cc4ee7091b423db0f91bbe2b0b1908.jpg",
      accessibility: "Ein Satz verschiedener Bohrer und Zentrierspitzen in einer grünen Box.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe9cc4ee7091b423db0f91bbe2b0b1908.jpg",
      "https://www.lidl.de/assets/gcp87011a733b094e278f8d8ac78fb56ab8.jpg",
      "https://www.lidl.de/assets/gcp15249faf00e742158ac67923fda58a09.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe9cc4ee7091b423db0f91bbe2b0b1908.jpg",
        accessibility: "Ein Satz verschiedener Bohrer und Zentrierspitzen in einer grünen Box.",
      },
      {
        image: "https://www.lidl.de/assets/gcp87011a733b094e278f8d8ac78fb56ab8.jpg",
        accessibility: "Ein Bohrerset in einer grünen Box.",
      },
      {
        image: "https://www.lidl.de/assets/gcp15249faf00e742158ac67923fda58a09.jpg",
        accessibility: "Ein Satz verschiedener Bohrer für Holz und Metall.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
      description: "",
      fullTitle: "PARKSIDE® Bohrer-Set",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Art: </strong>HSS-Spiralbohrer / HSS-Querlochsenker / HSS-Blechsch&auml;lbohrer / HSS-Kegel- und Entgratsenker</p>",
      title: "Bohrer-Set",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 11.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        percentageDiscount: 58,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 11.99,
      price: 4.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100381667,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.7,
      count: 9,
      recommendedNo: 1,
      recommendedYes: 8,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770027277,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1763161200,
    title: "Bohrer-Set",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-gewindebohrer-set-kegelsenker-set-bohrer-set/p100385314",
    canonicalUrl: "/p/parkside-gewindebohrer-set-kegelsenker-set-bohrer-set/p100385314",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
    categorySecondaryPath: "0/41/4111/411119/41111988",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100385314_4dfa992c",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100385314_491ab98e",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100385314",
    flashSales: false,
    fullTitle: "PARKSIDE® Gewindebohrer-Set / Kegelsenker-Set / Bohrer-Set",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["457940"],
    image: "https://www.lidl.de/assets/gcpe6b80fcb78a64c4d99a8d915bdd40679.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe6b80fcb78a64c4d99a8d915bdd40679.jpg",
      accessibility: "Vier Sets Parkside Werkzeug, darunter Bohrer und Gewindeschneider.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe6b80fcb78a64c4d99a8d915bdd40679.jpg",
      "https://www.lidl.de/assets/gcp9fe2ce9a6e1948ae90c06950d0ae79d0.jpg",
      "https://www.lidl.de/assets/gcp8d03c2de7fe640b3bef316aa076c5027.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe6b80fcb78a64c4d99a8d915bdd40679.jpg",
        accessibility: "Vier Sets Parkside Werkzeug, darunter Bohrer und Gewindeschneider.",
      },
      {
        image: "https://www.lidl.de/assets/gcp9fe2ce9a6e1948ae90c06950d0ae79d0.jpg",
        accessibility: "Parkside Gewindeschneider-Set mit 6 Bohrer und einem Halter",
      },
      {
        image: "https://www.lidl.de/assets/gcp8d03c2de7fe640b3bef316aa076c5027.jpg",
        accessibility: "Parkside Bohrer-Set in einer Plastikbox.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Bohrersets",
      description: '<p><span style="color: #0050aa;">✓</span> 1 Schnellwechsel-Bithalter&nbsp;&nbsp;</p>',
      fullTitle: "PARKSIDE® Gewindebohrer-Set / Kegelsenker-Set / Bohrer-Set",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<p><strong>Set:</strong>&nbsp;6x Bohrer, 1x Bithalter&nbsp;&nbsp;</p>",
      title: "Gewindebohrer-Set / Kegelsenker-Set / Bohrer-Set",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 11.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        percentageDiscount: 50,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 11.99,
      price: 5.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100385314,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4,
      count: 4,
      recommendedNo: 1,
      recommendedYes: 3,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770027224,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1763161200,
    title: "Gewindebohrer-Set / Kegelsenker-Set / Bohrer-Set",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-12-v-2-ah-akku-papk-12-a4-und-ladegeraet-plgk-12-a3/p100388457",
    canonicalUrl: "/p/parkside-12-v-2-ah-akku-papk-12-a4-und-ladegeraet-plgk-12-a3/p100388457",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100388457_217df568",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100388457_b548b204",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100388457",
    flashSales: false,
    fullTitle: "PARKSIDE® 12 V / 2 Ah Akku »PAPK 12 A4« und Ladegerät »PLGK 12 A3«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["472707"],
    image: "https://www.lidl.de/assets/gcpbc1bd0dab2cd44298ee840af76dedfc0.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpbc1bd0dab2cd44298ee840af76dedfc0.jpg",
      accessibility: "Parkside X12Team Ladegerät und 20Ah Akku.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpbc1bd0dab2cd44298ee840af76dedfc0.jpg",
      "https://www.lidl.de/assets/gcp5890ea989d634a3ca832dae92ccb1869.jpg",
      "https://www.lidl.de/assets/gcp5c856b8de2c440d5963de4951ab08854.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpbc1bd0dab2cd44298ee840af76dedfc0.jpg",
        accessibility: "Parkside X12Team Ladegerät und 20Ah Akku.",
      },
      {
        image: "https://www.lidl.de/assets/gcp5890ea989d634a3ca832dae92ccb1869.jpg",
        accessibility: "Akkuladegerät und Akku für Elektrowerkzeuge.",
      },
      {
        image: "https://www.lidl.de/assets/gcp5c856b8de2c440d5963de4951ab08854.jpg",
        accessibility: "Parkside X12V Team Akku für Elektrowerkzeuge.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      description:
        '<p><span style="color: #0050aa;">✓</span> Leistungsstark<br /> <span style="color: #0050aa;">✓</span> Cell Balancing<br /> <span style="color: #0050aa;">✓</span> Antirutsch-F&uuml;&szlig;e</p>',
      fullTitle: "PARKSIDE® 12 V / 2 Ah Akku »PAPK 12 A4« und Ladegerät »PLGK 12 A3«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <span style="color: #226456;"><strong>PARKSIDE X 12 V Team</strong></span><br /> <strong>Bemessungsaufnahme</strong>: 50 W<br /> <strong>Ladestrom</strong>: 2,4 A</p>',
      title: "12 V / 2 Ah Akku »PAPK 12 A4« und Ladegerät »PLGK 12 A3«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 19.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100388457,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 152,
      recommendedNo: 4,
      recommendedYes: 139,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770025455,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "12 V / 2 Ah Akku »PAPK 12 A4« und Ladegerät »PLGK 12 A3«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-wandhalterung-fuer-akkus-der-serie-x-20-v-team/p100391528",
    canonicalUrl: "/p/parkside-wandhalterung-fuer-akkus-der-serie-x-20-v-team/p100391528",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100391528_4186a3a6",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100391528_38b3b92d",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100391528",
    flashSales: false,
    fullTitle: 'PARKSIDE® Wandhalterung, für Akkus der Serie "X 20 V Team"',
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["479357"],
    image: "https://www.lidl.de/assets/gcp22e77d12513844f79a156518666200ad.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp22e77d12513844f79a156518666200ad.jpg",
      accessibility: "",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp22e77d12513844f79a156518666200ad.jpg",
      "https://www.lidl.de/assets/gcp82c53507ba254c8b85d07a68ee3ac79b.jpg",
      "https://www.lidl.de/assets/gcp285c6e2a09214a9fa3b8d8f831eb6f55.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp22e77d12513844f79a156518666200ad.jpg",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcp82c53507ba254c8b85d07a68ee3ac79b.jpg",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcp285c6e2a09214a9fa3b8d8f831eb6f55.jpg",
        accessibility: "",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: 'PARKSIDE® Wandhalterung, für Akkus der Serie "X 20 V Team"',
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<p><strong>Geeignet f&uuml;r</strong>: 20 V Akkus; 20 V Akku-Schrauber</p>",
      title: 'Wandhalterung, für Akkus der Serie "X 20 V Team"',
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 4.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100391528,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.9,
      count: 53,
      recommendedNo: 0,
      recommendedYes: 48,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770026170,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: 'Wandhalterung, für Akkus der Serie "X 20 V Team"',
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-12-v-akku-bohrschrauber-pbspa-12-d4-ohne-akku-und-ladegeraet/p100392941",
    canonicalUrl: "/p/parkside-performance-12-v-akku-bohrschrauber-pbspa-12-d4-ohne-akku-und-ladegeraet/p100392941",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111997",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100392941_f63aca48",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100392941_ac82655a",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100392941",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 12 V Akku-Bohrschrauber »PBSPA 12 D4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["477828"],
    image: "https://www.lidl.de/assets/gcp88bf68a5d35f4168bbec6ba4a4be5e03.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp88bf68a5d35f4168bbec6ba4a4be5e03.jpg",
      accessibility: "Parkside Bohrschrauber mit Bohrfutter und Bohrer, ohne Akku.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp88bf68a5d35f4168bbec6ba4a4be5e03.jpg",
      "https://www.lidl.de/assets/gcp551a05dce4cd48a2bae36b8537861216.jpg",
      "https://www.lidl.de/assets/gcp2104ce1ed0dc429188928f8c1cbf244d.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp88bf68a5d35f4168bbec6ba4a4be5e03.jpg",
        accessibility: "Parkside Bohrschrauber mit Bohrfutter und Bohrer, ohne Akku.",
      },
      {
        image: "https://www.lidl.de/assets/gcp551a05dce4cd48a2bae36b8537861216.jpg",
        accessibility: "Parkside X 12V Team Akkuladegerät mit einem 2.0 Ah Akku.",
      },
      {
        image: "https://www.lidl.de/assets/gcp2104ce1ed0dc429188928f8c1cbf244d.jpg",
        accessibility: "Parkside Akku-Bohrmaschine mit Bohrer in der Wand",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
      fullTitle: "PARKSIDE PERFORMANCE® 12 V Akku-Bohrschrauber »PBSPA 12 D4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufdrehzahl</strong>: max. 1750 min<sup>-1</sup><br /> <strong>Drehmoment</strong>: max. 35 Nm</p>",
      title: "12 V Akku-Bohrschrauber »PBSPA 12 D4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 37.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 52,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 37.99,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100392941,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.7,
      count: 10,
      recommendedNo: 0,
      recommendedYes: 9,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770027321,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100388457",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "12 V Akku-Bohrschrauber »PBSPA 12 D4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-12-v-akku-handkreissaege-phksap-12-b2-ohne-akku-und-ladegeraet/p100393608",
    canonicalUrl: "/p/parkside-performance-12-v-akku-handkreissaege-phksap-12-b2-ohne-akku-und-ladegeraet/p100393608",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Kreissägen",
    categorySecondaryPath: "0/41/4111/411119/41111919",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100393608_db09226f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100393608_05438439",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100393608",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 12 V Akku-Handkreissäge »PHKSAP 12 B2«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["480902"],
    image: "https://www.lidl.de/assets/gcpc9d2c7aeb4a745f7b5b117165bcd5da7.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpc9d2c7aeb4a745f7b5b117165bcd5da7.jpg",
      accessibility: "Parkside Akku-Kreissäge mit bürstenlosem Motor und einstellbaren Funktionen.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpc9d2c7aeb4a745f7b5b117165bcd5da7.jpg",
      "https://www.lidl.de/assets/gcp0409247890b94d06a2af8ccd5a7dd752.jpg",
      "https://www.lidl.de/assets/gcpde5288e4bdb64048ae10db895bf2ceeb.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpc9d2c7aeb4a745f7b5b117165bcd5da7.jpg",
        accessibility: "Parkside Akku-Kreissäge mit bürstenlosem Motor und einstellbaren Funktionen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp0409247890b94d06a2af8ccd5a7dd752.jpg",
        accessibility: "Parkside X 12V Team Akku und Ladegerät mit gelbem Kreis und diagonaler Linie.",
      },
      {
        image: "https://www.lidl.de/assets/gcpde5288e4bdb64048ae10db895bf2ceeb.jpg",
        accessibility: "Eine Person benutzt eine Parkside Kreissäge auf einer Holzwerkbank.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Kreissägen",
      fullTitle: "PARKSIDE PERFORMANCE® 12 V Akku-Handkreissäge »PHKSAP 12 B2«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufdrehzahl</strong>: 3600 min<sup>-1</sup><br /> <strong>S&auml;geblatt-&Oslash;</strong>: ca. &Oslash; 140 mm</p>",
      title: "12 V Akku-Handkreissäge »PHKSAP 12 B2«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 59.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 50,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 59.99,
      price: 29.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100393608,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 3.5,
      count: 8,
      recommendedNo: 4,
      recommendedYes: 4,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770023852,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395394",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "2",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "12 V Akku-Handkreissäge »PHKSAP 12 B2«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100396674",
    canonicalUrl: "/p/parkside-20-v-2-ah-akku-pap-20-b1-mit-cell-balancing/p100396674",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396674_8d9979b1",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396674_63b430b8",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396674",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["485596"],
    image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
      accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
      "https://www.lidl.de/assets/gcpe79706d2a0714d4dbcb58174e9491289.jpg",
      "https://www.lidl.de/assets/gcp91a957949deb4104a93059a7e96782fe.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp65911e71c7794e1d8dff54d9bf7ce901.jpg",
        accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
      },
      {
        image: "https://www.lidl.de/assets/gcpe79706d2a0714d4dbcb58174e9491289.jpg",
        accessibility: "Schwarzer und roter Akku für Elektrowerkzeuge mit Ladeanzeige.",
      },
      {
        image: "https://www.lidl.de/assets/gcp91a957949deb4104a93059a7e96782fe.jpg",
        accessibility: "Schwarz-roter Akku für Elektrowerkzeuge mit X20V Team Logo",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (2 Ah)</p>',
      title: "20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396674,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 103,
      recommendedNo: 3,
      recommendedYes: 99,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770025597,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 2 Ah Akku »PAP 20 B1«, mit Cell Balancing",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-akku-bohrschrauber-pabsp-20-li-c4-ohne-akku-und-ladegeraet/p100396678",
    canonicalUrl: "/p/parkside-performance-20-v-akku-bohrschrauber-pabsp-20-li-c4-ohne-akku-und-ladegeraet/p100396678",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111997",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100396678_3403267a",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100396678_e93ee1e9",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100396678",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 2,
    ians: ["485609"],
    image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
      accessibility: "Akku-Bohrschrauber mit bürstenlosem Motor und 60 Nm Drehmoment",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
      "https://www.lidl.de/assets/gcpc1d4be45ff6e4c0c9ec9e3cbc616fbc2.jpg",
      "https://www.lidl.de/assets/gcp066714c18ad2448ea9d15c394ca262bd.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3499ef846658404e9ef99f07de5bef21.jpg",
        accessibility: "Akku-Bohrschrauber mit bürstenlosem Motor und 60 Nm Drehmoment",
      },
      {
        image: "https://www.lidl.de/assets/gcpc1d4be45ff6e4c0c9ec9e3cbc616fbc2.jpg",
        accessibility:
          "Ein Akku wird auf einem Ladegerät geladen, mit einem gelben Kreis und Kreuz, das anzeigt, dass dies nicht erlaubt ist.",
      },
      {
        image: "https://www.lidl.de/assets/gcp066714c18ad2448ea9d15c394ca262bd.jpg",
        accessibility: "Bürstenloser Akku-Bohrschrauber mit 4 Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Bohrschrauber",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Leerlaufdrehzahl</strong>: max. 0&ndash;2000 min⁻&sup1;<br /> <strong>Drehmoment</strong>: max. 60 Nm</p>",
      title: "20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 54.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 27,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 54.99,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100396678,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.5,
      count: 27,
      recommendedNo: 3,
      recommendedYes: 23,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1770019710,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "auch in der Filiale von 09.02. - 14.02.",
            type: "ALSO_IN_STORE_FROM_FUTURE_DATE_RANGE",
          },
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeStartDate: 1770591600,
    storeEndDate: 1771023600,
    title: "20 V Akku-Bohrschrauber »PABSP 20 Li C4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    canonicalUrl: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100397995_23eadd7b",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100397995_09205bd7",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100397995",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496305"],
    image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
      "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
        accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
      },
      {
        image: "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Akku in Schwarz-Rot-Design",
      },
      {
        image: "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
        accessibility: "PARKSIDE 20V 2.0Ah Akku mit grüner Ladeanzeige",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (2 Ah)<br /> <strong>Ladestrom</strong>: 2,4 A</p>',
      title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 22.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100397995,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769986855,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1« ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    canonicalUrl: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398189_807d5a8f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398189_cf33db0b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398189",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496285"],
    image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
      "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
        accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku auf einer Holzwerkbank",
      },
      {
        image: "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>',
      title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398189,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020843,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-schlagbohrschrauber-psbsa-20-li-e4-ohne-akku-und-ladegeraet/p100398278",
    canonicalUrl: "/p/parkside-20-v-akku-schlagbohrschrauber-psbsa-20-li-e4-ohne-akku-und-ladegeraet/p100398278",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Schlagbohrschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111999",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398278_5c553f74",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398278_29718025",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398278",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496277"],
    image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
      accessibility: "Parkside Akku-Bohrschrauber mit Akku",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
      "https://www.lidl.de/assets/gcp112853db11624f9ba422a55d13ce91a8.jpg",
      "https://www.lidl.de/assets/gcpa2a42b78c8904521875c0ff8a15dcfda.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
        accessibility: "Parkside Akku-Bohrschrauber mit Akku",
      },
      {
        image: "https://www.lidl.de/assets/gcp112853db11624f9ba422a55d13ce91a8.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcpa2a42b78c8904521875c0ff8a15dcfda.jpg",
        accessibility: "Person bohrt mit einem Parkside Akku-Bohrschrauber in eine Ziegelwand.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Schlagbohrschrauber",
      fullTitle: "PARKSIDE® 20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Schlagzahl</strong>: 26.400 min<sup>-1</sup><br /> <strong>Drehmoment</strong>: max. 45 Nm</p>',
      title: "20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398278,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.7,
      count: 345,
      recommendedNo: 8,
      recommendedYes: 300,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770015647,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-bandfeile-pbfa-20-li-a1-ohne-akku-und-ladegeraet/p100398430",
    canonicalUrl: "/p/parkside-20-v-akku-bandfeile-pbfa-20-li-a1-ohne-akku-und-ladegeraet/p100398430",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
    categorySecondaryPath: "0/41/4111/411119/41111928",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398430_14daba1c",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398430_cfb539a7",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398430",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496297"],
    image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
      accessibility: "PARKSIDE Akku-Bandschleifer PBFA 20-LI A1",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
      "https://www.lidl.de/assets/gcp7faa118e98c645678456d815eb5a0d30.jpg",
      "https://www.lidl.de/assets/gcp7dd614c785414a2fb36cbb654da58325.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
        accessibility: "PARKSIDE Akku-Bandschleifer PBFA 20-LI A1",
      },
      {
        image: "https://www.lidl.de/assets/gcp7faa118e98c645678456d815eb5a0d30.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp7dd614c785414a2fb36cbb654da58325.jpg",
        accessibility: "Parkside Akku-Bandschleifer mit Akku, auf einer Holzwerkbank bedient.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
      fullTitle: "PARKSIDE® 20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Bandgeschwindigkeit</strong>: 600&ndash;1700 m/min<br /> <strong>Bandabmessung</strong>: ca. 9 x 533 mm</p>',
      title: "20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398430,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 47,
      recommendedNo: 4,
      recommendedYes: 43,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020846,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    canonicalUrl: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    category: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
    categorySecondaryPath: "0/41/4111/411118/41111812",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398778_0d5cfdc7",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398778_a8c4ff27",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398778",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["525408"],
    image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
      "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
        accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
      },
      {
        image: "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit rotem Kreuz darüber.",
      },
      {
        image: "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
        accessibility: "PARKSIDE elektrische Luftpumpe bläst eine blaue Luftmatratze auf einem Teppich auf.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
      fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Druck</strong>: max. 10,3 bar</p>',
      title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 32.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398778,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770021864,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/gcp2a99462842054306a6542ff3be0602c3.jpeg",
      name: "PARKSIDE PERFORMANCE®",
      url: "https://www.lidl.de/q/query/alle-parkside-performance-produkte",
      id: "PARP",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-performance-20-v-8-ah-smart-akku-papp-208-a1/p100399718",
    canonicalUrl: "/p/parkside-performance-20-v-8-ah-smart-akku-papp-208-a1/p100399718",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100399718_3daaa80e",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100399718_8329b38d",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100399718",
    flashSales: false,
    fullTitle: "PARKSIDE PERFORMANCE® 20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496304"],
    image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
      accessibility: "PARKSIDE PERFORMANCE 8.0Ah X 20V TEAM Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
      "https://www.lidl.de/assets/gcp214a09506c7345f896466214dbc004cf.jpg",
      "https://www.lidl.de/assets/gcp9c5406d1bc7046e1a4fc3ac0685ce374.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp5e69be615209490197ca3ef81eb52e51.jpg",
        accessibility: "PARKSIDE PERFORMANCE 8.0Ah X 20V TEAM Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp214a09506c7345f896466214dbc004cf.jpg",
        accessibility: "PARKSIDE X 20V Team 8.0Ah Akku mit grünem Licht, schwebend vor Betonhintergrund.",
      },
      {
        image: "https://www.lidl.de/assets/gcp9c5406d1bc7046e1a4fc3ac0685ce374.jpg",
        accessibility: "Parkside Performance X 20V Team 8.0Ah Akku, schwarz und rot.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE PERFORMANCE® 20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p>Aus der Serie PARKSIDE PERFORMANCE<br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 8 Ah</p>",
      title: "20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      endDate: "2026-02-08T23:00",
      hasStar: true,
      hasVat: true,
      price: 59.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100399718,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769901257,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "20 V / 8 Ah Smart-Akku »PAPP 208 A1«",
    zones: {},
  },
];

export const brandGridboxResponse = [
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-fraesbits-fuer-oberfraese-pfb-12-a1/p100324645",
    canonicalUrl: "/p/parkside-fraesbits-fuer-oberfraese-pfb-12-a1/p100324645",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Elektrohobel & Fräsen",
    categorySecondaryPath: "0/41/4111/411119/41111914",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100324645_29902be0",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100324645_521b86dd",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100324645",
    flashSales: false,
    fullTitle: "PARKSIDE® Fräsbits für Oberfräse PFB 12 A1",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 3,
    ians: ["360692"],
    image: "https://www.lidl.de/assets/dc801bc14501a4f9474088a48639c8bf.jpeg",
    image_V1: {
      image: "https://www.lidl.de/assets/dc801bc14501a4f9474088a48639c8bf.jpeg",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/dc801bc14501a4f9474088a48639c8bf.jpeg",
      "https://www.lidl.de/assets/f82f8fc5fbac648018db9e3e84182bc5.jpeg",
      "https://www.lidl.de/assets/e39086b0f4c0218683d8712ba78daa13.jpeg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/dc801bc14501a4f9474088a48639c8bf.jpeg",
      },
      {
        image: "https://www.lidl.de/assets/f82f8fc5fbac648018db9e3e84182bc5.jpeg",
      },
      {
        image: "https://www.lidl.de/assets/e39086b0f4c0218683d8712ba78daa13.jpeg",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Elektrohobel & Fräsen",
      description:
        '<p><span style="color: #0050aa;">✓</span> Zum Fr&auml;sen, Verrunden, Nuten und rechtwinkligen Schneiden<br /> <span style="color: #0050aa;">✓</span> Geeignet f&uuml;r Weichholz, MDF, Spanplatten, Sperrholz<br /> <span style="color: #0050aa;">✓</span> Kompatibel zur Parkside Oberfr&auml;se POF 1200.</p>',
      fullTitle: "PARKSIDE® Fräsbits für Oberfräse PFB 12 A1",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<strong>Set:</strong> 12-teilig",
      title: "Fräsbits für Oberfräse PFB 12 A1",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Handwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1214",
    },
    lidlPlus: [],
    mouseoverImage: "https://www.lidl.de/assets/e39086b0f4c0218683d8712ba78daa13.jpeg",
    mouseoverImage_V1: {
      image: "https://www.lidl.de/assets/e39086b0f4c0218683d8712ba78daa13.jpeg",
    },
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 17.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100324645,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.8,
      count: 338,
      recommendedNo: 0,
      recommendedYes: 147,
      sizePercentage: 0,
      topRated: true,
      text: "Top Kundenbewertungen",
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "TOP_RATED",
        text: "Top Kundenbewertungen",
        theme: "top-rated",
        icon: "star-10",
      },
    ],
    renderedTs: 1770026750,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Fräsbits für Oberfräse PFB 12 A1 ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-tacker-sortiment-petz-25-a4-aus-verzinktem-stahl/p100385250",
    canonicalUrl: "/p/parkside-tacker-sortiment-petz-25-a4-aus-verzinktem-stahl/p100385250",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
    categorySecondaryPath: "0/41/4111/411119/41111928",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100385250_2572c6f9",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100385250_a38d4fa4",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100385250",
    flashSales: false,
    fullTitle: "PARKSIDE® Tacker Sortiment »PETZ 25 A4«, aus verzinktem Stahl",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["465585"],
    image: "https://www.lidl.de/assets/gcp8de7806aea754302aeb983e61fc74665.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp8de7806aea754302aeb983e61fc74665.jpg",
      accessibility: "Stapel von silbernen Heftklammern für eine Hefter.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp8de7806aea754302aeb983e61fc74665.jpg",
      "https://www.lidl.de/assets/gcp0d3f6407fde74d5789a1ea12b45be94b.jpg",
      "https://www.lidl.de/assets/gcp984c65e604a244cca1b1bb0e917752be.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp8de7806aea754302aeb983e61fc74665.jpg",
        accessibility: "Stapel von silbernen Heftklammern für eine Hefter.",
      },
      {
        image: "https://www.lidl.de/assets/gcp0d3f6407fde74d5789a1ea12b45be94b.jpg",
        accessibility: "Zwei Packungen Klammern für einen Hefter.",
      },
      {
        image: "https://www.lidl.de/assets/gcp984c65e604a244cca1b1bb0e917752be.jpg",
        accessibility: "Zwei Streifen silberner Klammern für eine Tacker.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
      description:
        '<p><span style="color: #0050aa;">✓</span> F&uuml;r g&auml;ngige Hand-, Elektro- und Akku-Tacker geeignet</p>',
      fullTitle: "PARKSIDE® Tacker Sortiment »PETZ 25 A4«, aus verzinktem Stahl",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Set</strong>: 2000/3000 St&uuml;ck<br /> <strong>Art</strong>: Klammer/Nagel<br /> <strong>Typ</strong>: 55/47</p>",
      title: "Tacker Sortiment »PETZ 25 A4«, aus verzinktem Stahl",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Werkstatt & Eisenwaren",
      wonCategoryPrimaryPath: "0/12/1213",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 3.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        percentageDiscount: 67,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 3.99,
      price: 1.29,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100385250,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 64,
      recommendedNo: 8,
      recommendedYes: 52,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770023862,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Tacker Sortiment »PETZ 25 A4«, aus verzinktem Stahl",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath:
      "/p/parkside-schlagschraubendreher-set-schraubenausdreher-set-mutternausdreher-set-8-teilig-6-teilig-5-teilig/p100387821",
    canonicalUrl:
      "/p/parkside-schlagschraubendreher-set-schraubenausdreher-set-mutternausdreher-set-8-teilig-6-teilig-5-teilig/p100387821",
    category: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Werkzeugsets & -koffer",
    categorySecondaryPath: "0/41/4111/411120/41112013",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100387821_b37f9465",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100387821_d98c5281",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100387821",
    flashSales: false,
    fullTitle:
      "PARKSIDE® Schlagschraubendreher-Set / Schraubenausdreher-Set / Mutternausdreher-Set, 8-teilig / 6-teilig / 5-teilig",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["469712"],
    image: "https://www.lidl.de/assets/gcpb863fc8bbca043be84cd1245700189ac.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpb863fc8bbca043be84cd1245700189ac.jpg",
      accessibility: "Parkside Werkzeugsets: Schlagschrauber, Steckschlüssel und abgebrochene Schrauben-Extraktor.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpb863fc8bbca043be84cd1245700189ac.jpg",
      "https://www.lidl.de/assets/gcpe77eca26dd2846a9b2e8d094abea7958.jpg",
      "https://www.lidl.de/assets/gcpea4bec9fad4647faab5f962060020440.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpb863fc8bbca043be84cd1245700189ac.jpg",
        accessibility: "Parkside Werkzeugsets: Schlagschrauber, Steckschlüssel und abgebrochene Schrauben-Extraktor.",
      },
      {
        image: "https://www.lidl.de/assets/gcpe77eca26dd2846a9b2e8d094abea7958.jpg",
        accessibility: "Parkside Schraubendrehersatz mit Schlagschrauber und Bits.",
      },
      {
        image: "https://www.lidl.de/assets/gcpea4bec9fad4647faab5f962060020440.jpg",
        accessibility: "Ein Schlagschrauber wird an einer Holzkiste verwendet.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Werkzeugsets & -koffer",
      description:
        '<p><span style="color: #0050aa;">✓</span> Aus hochwertigem Stahl gefertigt<br /> <span style="color: #0050aa;">✓</span> In praktischer Aufbewahrungsbox</p>',
      fullTitle:
        "PARKSIDE® Schlagschraubendreher-Set / Schraubenausdreher-Set / Mutternausdreher-Set, 8-teilig / 6-teilig / 5-teilig",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<p><strong>Set</strong>: 8-teilig / 6-teilig / 5-teilig</p>",
      title:
        "Schlagschraubendreher-Set / Schraubenausdreher-Set / Mutternausdreher-Set, 8-teilig / 6-teilig / 5-teilig",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Handwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1214",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 14.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        percentageDiscount: 66,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 14.99,
      price: 4.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100387821,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.1,
      count: 10,
      recommendedNo: 2,
      recommendedYes: 8,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770027160,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Schlagschraubendreher-Set / Schraubenausdreher-Set / Mutternausdreher-Set, 8-teilig / 6-teilig / 5-teilig",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-kapp-und-zugsaege-pzks-2000-c3-2000-w/p100388342",
    canonicalUrl: "/p/parkside-kapp-und-zugsaege-pzks-2000-c3-2000-w/p100388342",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Kapp- & Gehrungssägen",
    categorySecondaryPath: "0/41/4111/411119/41111918",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100388342_740209d7",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100388342_f6441c9e",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100388342",
    flashSales: false,
    fullTitle: "PARKSIDE® Kapp- und Zugsäge »PZKS 2000 C3«, 2000 W",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["471953"],
    image: "https://www.lidl.de/assets/gcpd08ab0e9a1ea46f6b629fbdf8f247e44.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpd08ab0e9a1ea46f6b629fbdf8f247e44.jpg",
      accessibility: "Parkside Gehrungssäge: Kapp- und Gehrungssäge mit Zubehör.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpd08ab0e9a1ea46f6b629fbdf8f247e44.jpg",
      "https://www.lidl.de/assets/gcpe52b5da92dcd4284997eed7a8045f4cb.jpg",
      "https://www.lidl.de/assets/gcpc1a47ef7a1fb44298e5f16dd46658be6.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpd08ab0e9a1ea46f6b629fbdf8f247e44.jpg",
        accessibility: "Parkside Gehrungssäge: Kapp- und Gehrungssäge mit Zubehör.",
      },
      {
        image: "https://www.lidl.de/assets/gcpe52b5da92dcd4284997eed7a8045f4cb.jpg",
        accessibility: "Ein Mann verwendet eine Parkside-Kapp- und Gehrungssäge zum Holzschneiden.",
      },
      {
        image: "https://www.lidl.de/assets/gcpc1a47ef7a1fb44298e5f16dd46658be6.jpg",
        accessibility: "Parkside Gehrungssäge: Elektrowerkzeug für präzise Schnitte.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Kapp- & Gehrungssägen",
      fullTitle: "PARKSIDE® Kapp- und Zugsäge »PZKS 2000 C3«, 2000 W",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p><span style="color: #0050aa;">✓</span> Laser für erhöhte Schnittpräzision<br /><span style="color: #0050aa;">✓</span> Stufenlos neigbarer Sägekopf<br /><span style="color: #0050aa;">✓</span> Gehrung kontinuierlich oder mit Fixwinkeln einstellbar</p>',
      title: "Kapp- und Zugsäge »PZKS 2000 C3«, 2000 W",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Elektrowerkzeuge",
      wonCategoryPrimaryPath: "0/12/1211",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 98.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 19,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 98.99,
      price: 79.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100388342,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 64,
      recommendedNo: 3,
      recommendedYes: 61,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769978175,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    title: "Kapp- und Zugsäge »PZKS 2000 C3«, 2000 W ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-rohrreinigungsspirale-mit-handkurbel/p100392312",
    canonicalUrl: "/p/parkside-rohrreinigungsspirale-mit-handkurbel/p100392312",
    category: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Handwerkzeuge",
    categorySecondaryPath: "0/41/4111/411120/41112011",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100392312_f48ca3bb",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100392312_16e5e509",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100392312",
    flashSales: false,
    fullTitle: "PARKSIDE® Rohrreinigungsspirale, mit Handkurbel",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["479536"],
    image: "https://www.lidl.de/assets/gcpd471b4eb1fd7445b98cdc605d38820dc.png",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpd471b4eb1fd7445b98cdc605d38820dc.png",
      accessibility: "",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpd471b4eb1fd7445b98cdc605d38820dc.png",
      "https://www.lidl.de/assets/gcp499cadf6612d4a0dbfd4d772fc66e4cd.png",
      "https://www.lidl.de/assets/gcpe5be9c7ec5d546c7a4f1b2261b6280d6.png",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpd471b4eb1fd7445b98cdc605d38820dc.png",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcp499cadf6612d4a0dbfd4d772fc66e4cd.png",
        accessibility: "",
      },
      {
        image: "https://www.lidl.de/assets/gcpe5be9c7ec5d546c7a4f1b2261b6280d6.png",
        accessibility: "",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Handwerkzeuge",
      fullTitle: "PARKSIDE® Rohrreinigungsspirale, mit Handkurbel",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        "<p><strong>Material</strong>: Stahl, Kunststoff<br /> <strong>Durchmesser</strong>: ca. 6,3 mm</p>",
      title: "Rohrreinigungsspirale, mit Handkurbel",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Handwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1214",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      discount: {
        deletedPrice: 29.99,
        discountHasStar: false,
        fromRecommendedPrice: false,
        hideBargainHint: false,
        percentageDiscount: 66,
        showDiscount: true,
        showFrom: false,
        showPercentage: true,
        showUpTo: false,
      },
      hasStar: true,
      hasVat: true,
      oldPrice: 29.99,
      price: 9.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100392312,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.2,
      count: 39,
      recommendedNo: 5,
      recommendedYes: 33,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [
      {
        type: "LIDL_HIGHLIGHT",
        text: "Lidl Tipp",
        theme: "green",
        icon: "party_popper",
      },
    ],
    renderedTs: 1769858548,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1758319200,
    title: "Rohrreinigungsspirale, mit Handkurbel ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    canonicalUrl: "/p/parkside-20-v-akku-pap-202-a1-20-v-akku-ladegeraet-plg-20-c1/p100397995",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
    categorySecondaryPath: "0/41/4111/411119/41111910",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100397995_23eadd7b",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100397995_09205bd7",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100397995",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496305"],
    image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
      "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
      "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp750ca81c0b584637afcee4a841bf472a.jpg",
        accessibility: "PARKSIDE X 20V Team Akku und 2,4A Ladegerät",
      },
      {
        image: "https://www.lidl.de/assets/gcpcf66a7bd83474e4289fefe17a228435d.jpg",
        accessibility: "PARKSIDE X 20V Team 2.0Ah Akku in Schwarz-Rot-Design",
      },
      {
        image: "https://www.lidl.de/assets/gcp0afffd7c352c4c1585dcfecd03bac57f.jpg",
        accessibility: "PARKSIDE 20V 2.0Ah Akku mit grüner Ladeanzeige",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akkus & Ladegeräte",
      fullTitle: "PARKSIDE® 20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku: </strong> 20 V (2 Ah)<br /> <strong>Ladestrom</strong>: 2,4 A</p>',
      title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 22.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100397995,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769986855,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku »PAP 202 A1« / 20 V Akku-Ladegerät »PLG 20 C1« ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    canonicalUrl: "/p/parkside-20-v-4-ah-akku-pap-204-a1-ohne-ladegeraet/p100398189",
    category: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
    categorySecondaryPath: "0/41/4111/411117/41111730",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398189_807d5a8f",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398189_cf33db0b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398189",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496285"],
    image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
      "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
      "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpe2bce6bda6fc4545bdd8bae8de2e63d2.jpg",
        accessibility: "PARKSIDE X 20V Team 4.0Ah Akku, schwarz und rot",
      },
      {
        image: "https://www.lidl.de/assets/gcp818120a567b84f8fb86ec1ca10f02aac.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku auf einer Holzwerkbank",
      },
      {
        image: "https://www.lidl.de/assets/gcpba4ed3e94cd843c2ab62479fdc902d31.jpg",
        accessibility: "Parkside X 20V Team 4.0Ah Akku",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Autozubehör/Aufbewahrung & sontiges",
      fullTitle: "PARKSIDE® 20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Akku-Spannung</strong>: 20 V<br /> <strong>Akku-Kapazit&auml;t</strong>: 4 Ah</p>',
      title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 24.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398189,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020843,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V / 4 Ah Akku »PAP 204 A1«, ohne Ladegerät ",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-schlagbohrschrauber-psbsa-20-li-e4-ohne-akku-und-ladegeraet/p100398278",
    canonicalUrl: "/p/parkside-20-v-akku-schlagbohrschrauber-psbsa-20-li-e4-ohne-akku-und-ladegeraet/p100398278",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Schlagbohrschrauber",
    categorySecondaryPath: "0/41/4111/411119/41111999",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398278_5c553f74",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398278_29718025",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398278",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496277"],
    image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
      accessibility: "Parkside Akku-Bohrschrauber mit Akku",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
      "https://www.lidl.de/assets/gcp112853db11624f9ba422a55d13ce91a8.jpg",
      "https://www.lidl.de/assets/gcpa2a42b78c8904521875c0ff8a15dcfda.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp89c09f3f92fe4f23a0608d2c630e897c.jpg",
        accessibility: "Parkside Akku-Bohrschrauber mit Akku",
      },
      {
        image: "https://www.lidl.de/assets/gcp112853db11624f9ba422a55d13ce91a8.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcpa2a42b78c8904521875c0ff8a15dcfda.jpg",
        accessibility: "Person bohrt mit einem Parkside Akku-Bohrschrauber in eine Ziegelwand.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Akku Schlagbohrschrauber",
      fullTitle: "PARKSIDE® 20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Schlagzahl</strong>: 26.400 min<sup>-1</sup><br /> <strong>Drehmoment</strong>: max. 45 Nm</p>',
      title: "20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398278,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.7,
      count: 345,
      recommendedNo: 8,
      recommendedYes: 300,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770015647,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Schlagbohrschrauber »PSBSA 20-Li E4«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-bandfeile-pbfa-20-li-a1-ohne-akku-und-ladegeraet/p100398430",
    canonicalUrl: "/p/parkside-20-v-akku-bandfeile-pbfa-20-li-a1-ohne-akku-und-ladegeraet/p100398430",
    category: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
    categorySecondaryPath: "0/41/4111/411119/41111928",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398430_14daba1c",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398430_cfb539a7",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398430",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["496297"],
    image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
      accessibility: "PARKSIDE Akku-Bandschleifer PBFA 20-LI A1",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
      "https://www.lidl.de/assets/gcp7faa118e98c645678456d815eb5a0d30.jpg",
      "https://www.lidl.de/assets/gcp7dd614c785414a2fb36cbb654da58325.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcpb85088d199b94a05bd88cc7a49fdc03a.jpg",
        accessibility: "PARKSIDE Akku-Bandschleifer PBFA 20-LI A1",
      },
      {
        image: "https://www.lidl.de/assets/gcp7faa118e98c645678456d815eb5a0d30.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit gelbem Verbotszeichen.",
      },
      {
        image: "https://www.lidl.de/assets/gcp7dd614c785414a2fb36cbb654da58325.jpg",
        accessibility: "Parkside Akku-Bandschleifer mit Akku, auf einer Holzwerkbank bedient.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Akku & Elektrowerkzeuge/Weitere Akku & Elektrowerkzeuge",
      fullTitle: "PARKSIDE® 20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Bandgeschwindigkeit</strong>: 600&ndash;1700 m/min<br /> <strong>Bandabmessung</strong>: ca. 9 x 533 mm</p>',
      title: "20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 39.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398430,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.6,
      count: 47,
      recommendedNo: 4,
      recommendedYes: 43,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770020846,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Bandfeile »PBFA 20-Li A1«, ohne Akku und Ladegerät",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-digitales-kalibrier-messwerkzeug-pdkm-a1-digitales-massband-pdmb-a1/p100398629",
    canonicalUrl: "/p/parkside-digitales-kalibrier-messwerkzeug-pdkm-a1-digitales-massband-pdmb-a1/p100398629",
    category: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Messwerkzeuge",
    categorySecondaryPath: "0/41/4111/411120/41112017",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398629_adb81948",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398629_bb105d0b",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398629",
    flashSales: false,
    fullTitle: "PARKSIDE® Digitales Kalibrier-Messwerkzeug »PDKM A1« / Digitales Maßband »PDMB A1«",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["495151"],
    image: "https://www.lidl.de/assets/gcp543b4e33ecb848fca8bdc95fe05ab36c.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp543b4e33ecb848fca8bdc95fe05ab36c.jpg",
      accessibility: "PARKSIDE digitales Messwerkzeug und digitales Maßband mit Laser.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp543b4e33ecb848fca8bdc95fe05ab36c.jpg",
      "https://www.lidl.de/assets/gcp0a26ec40e96a47e7a9e8ae8ce666a863.jpg",
      "https://www.lidl.de/assets/gcpdaed83fd94f446baa0f0f7c32587a675.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp543b4e33ecb848fca8bdc95fe05ab36c.jpg",
        accessibility: "PARKSIDE digitales Messwerkzeug und digitales Maßband mit Laser.",
      },
      {
        image: "https://www.lidl.de/assets/gcp0a26ec40e96a47e7a9e8ae8ce666a863.jpg",
        accessibility: "PARKSIDE digitales Kalibrier-Messwerkzeug mit rotem Messrad und Anzeige von 24.60 cm.",
      },
      {
        image: "https://www.lidl.de/assets/gcpdaed83fd94f446baa0f0f7c32587a675.jpg",
        accessibility: "PARKSIDE digitaler Winkelmesser, der 24,60 cm und 0,0° auf Holz misst.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Werkstatteinrichtung/Messwerkzeuge",
      fullTitle: "PARKSIDE® Digitales Kalibrier-Messwerkzeug »PDKM A1« / Digitales Maßband »PDMB A1«",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription: "<p><strong>Messgenauigkeit</strong>: &plusmn; 0,5 mm</p>",
      title: "Digitales Kalibrier-Messwerkzeug »PDKM A1« / Digitales Maßband »PDMB A1«",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Handwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1214",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 22.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398629,
    productType: "HEAD_VARIANT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 4.4,
      count: 67,
      recommendedNo: 10,
      recommendedYes: 55,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1769789012,
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1768604400,
    title: "Digitales Kalibrier-Messwerkzeug »PDKM A1« / Digitales Maßband »PDMB A1«",
    zones: {},
  },
  {
    ageRestriction: false,
    awards: [],
    brand: {
      logo: "https://www.lidl.de/assets/e04092d839176694263798baaca7efe5.png",
      name: "PARKSIDE®",
      url: "/q/search?q=parkside",
      id: "PARK",
      showBrand: true,
    },
    canonicalPath: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    canonicalUrl: "/p/parkside-20-v-akku-kompressor-und-luftpumpe-pka-20-li-c3-ohne-akku-und-ladegeraet/p100398778",
    category: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
    categorySecondaryPath: "0/41/4111/411118/41111812",
    dealOfDay: {
      active: false,
    },
    designTheme: "default",
    disclaimers: [
      {
        id: "code_100398778_0d5cfdc7",
        type: "CODE",
        value: "Basic",
      },
      {
        id: "code_100398778_a8c4ff27",
        type: "CODE",
        value: "Price",
      },
    ],
    displayFreeDelivery: false,
    energyLabels: [],
    erpNumber: "100398778",
    flashSales: false,
    fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    gs1Attributes: [],
    havingPrice: true,
    havingThreesixty: false,
    havingVideos: false,
    highlightedSeals: 0,
    ians: ["525408"],
    image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
    image_V1: {
      image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
    },
    isUsedProduct: false,
    imageList: [
      "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
      "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
      "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
    ],
    imageList_V1: [
      {
        image: "https://www.lidl.de/assets/gcp3764c9dd2b6e439982d891acc3527c3a.jpg",
        accessibility: "PARKSIDE X 20V TEAM Kompressor und Pumpe in Grün und Schwarz mit Schläuchen und Zubehör.",
      },
      {
        image: "https://www.lidl.de/assets/gcpaae506c7b53b466da90a48e861645d6d.jpg",
        accessibility: "PARKSIDE X 20 V Team Akku und Ladegerät mit rotem Kreuz darüber.",
      },
      {
        image: "https://www.lidl.de/assets/gcpb59c8a25b1ce4cc19e016fdd60edc4c4.jpg",
        accessibility: "PARKSIDE elektrische Luftpumpe bläst eine blaue Luftmatratze auf einem Teppich auf.",
      },
    ],
    keyfacts: {
      analyticsCategory: "Kategorien/Baumarkt/Werkstatt/Großmaschinen/Kompressoren",
      fullTitle: "PARKSIDE® 20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      moreDetails: "Weitere Produktdetails",
      supplementalDescription:
        '<p>Aus der Serie <strong><span style="color: #226456;">PARKSIDE X 20 V Team</span></strong><br /> <strong>Druck</strong>: max. 10,3 bar</p>',
      title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
      wonCategoryPrimary: "Bedürfniswelten/Baumarkt & Garten/Akkuwerkzeuge",
      wonCategoryPrimaryPath: "0/12/1210",
    },
    lidlPlus: [],
    multipack: false,
    online: true,
    preventSelling: false,
    price: {
      currencyCode: "EUR",
      currencyCodeSecond: "",
      currencySymbol: "€",
      currencySymbolSecond: "",
      hasStar: true,
      hasVat: true,
      price: 32.99,
      specialTaxes: [],
      variantsHaveDifferentPrices: false,
    },
    productId: 100398778,
    productType: "FLAT",
    productOrigin: "progress_event",
    quickAddToCart: false,
    ratings: {
      average: 5,
      count: 1,
      recommendedNo: 0,
      recommendedYes: 1,
      sizePercentage: 0,
      topRated: false,
    },
    regions: [],
    regionsPrices: {},
    ribbons: [],
    renderedTs: 1770021864,
    salesAttributes: {
      template: [
        {
          date: [],
          label: [
            {
              key: "Bundle",
              value: "100395395",
            },
          ],
          text: [],
          flag: [],
          list: [],
          id: 43001,
          name: "PDP Bundle",
          version: "4",
        },
      ],
    },
    seals: [],
    stockAvailability: {
      availabilityIndicator: 3,
      badgeInfo: {
        badges: [
          {
            text: "lieferbar",
            type: "AVAILABLE_ONLINE",
          },
        ],
      },
      onlineAvailable: true,
      orderableQuantities: [
        {
          unit: "Stück",
          value: 1,
        },
        {
          unit: "Stück",
          value: 2,
        },
        {
          unit: "Stück",
          value: 3,
        },
        {
          unit: "Stück",
          value: 4,
        },
        {
          unit: "Stück",
          value: 5,
        },
        {
          unit: "Stück",
          value: 6,
        },
        {
          unit: "Stück",
          value: 7,
        },
        {
          unit: "Stück",
          value: 8,
        },
        {
          unit: "Stück",
          value: 9,
        },
        {
          unit: "Stück",
          value: 10,
        },
      ],
      minOrderableQuantity: 1,
    },
    store: false,
    storeEndDate: 1769814000,
    title: "20 V Akku-Kompressor und -Luftpumpe »PKA 20-Li C3«, ohne Akku und Ladegerät",
    zones: {},
  },
];
